/* ============================================================
   GroomSkull® : theme.js
   ============================================================ */
(function () {
  'use strict';

  // UI text only. Transaction identities and verified Recharge plan names stay unchanged.
  const uiMessages = {
  "fr": {
    "shipping_free": "Livraison offerte en France",
    "shipping_checkout": "Frais de livraison calculés au paiement",
    "cart_render_error": "L’affichage du panier ne peut pas être chargé. Consultez votre panier.",
    "cart_verify_error": "Le panier ne peut pas être vérifié. Consultez votre panier avant de continuer.",
    "cart_render_check": "Le panier a été mis à jour, mais son affichage doit être vérifié. Consultez le panier avant de payer.",
    "cart_updating_check": "Le panier est encore en cours de mise à jour. Vérifiez son contenu avant de payer.",
    "display_unavailable": "Affichage indisponible",
    "cart_empty_error": "Votre panier est vide. Ajoutez un article avant de passer commande.",
    "cart_updating_retry": "Le panier change encore. Patientez un instant, puis réessayez.",
    "line_changed": "Cette ligne a changé. Rechargez votre panier avant de continuer.",
    "cart_change_failed": "Une modification du panier a échoué. Corrigez-la ou rechargez le panier.",
    "cart_change_before_checkout": "Une modification du panier a échoué. Corrigez-la ou rechargez le panier avant de payer.",
    "cart_verify_before_checkout": "Le panier doit être vérifié avant le paiement.",
    "added_check_cart": "Produit ajouté. Consultez le panier pour vérifier son contenu.",
    "checkout_timeout": "La préparation du paiement prend plus de temps que prévu. Réessayez dans un instant ou rechargez la page.",
    "cart_verify_reload": "Le panier ne peut pas être vérifié. Rechargez-le avant de réessayer.",
    "cart_verify_timeout": "La vérification du panier prend trop de temps. Réessayez dans un instant.",
    "checkout_preparing": "Préparation du paiement…",
    "cart_updated_check": "Votre panier a été mis à jour. Consultez-le pour vérifier son contenu.",
    "ritual_selected": "Le Rituel sélectionné",
    "one_time": "Achat unique",
    "one_time_lower": "achat unique",
    "added": "Ajouté au panier",
    "add": "Ajouter au panier",
    "adding": "Ajout…",
    "removing": "Suppression…",
    "cart_pending": "Mise à jour du panier…",
    "error": "Erreur",
    "ritual_added": "Le Rituel ajouté au panier",
    "cart_label": "Panier",
    "view_cart": "Consulter le panier",
    "image_zoom": "Image agrandie",
    "unavailable": "Indisponible",
    "plus_unavailable": "Le Pro 2+ est également indisponible. Notre équipe peut vous renseigner sur son retour.",
    "plus_plan_unavailable": "Cette formule n’est pas disponible sur le Pro 2+. Vous pouvez consulter ses formules en sélectionnant sa carte.",
    "choose_frequency": "Choisissez la fréquence",
    "choose_available_frequency": "Choisissez la fréquence disponible pour ce modèle.",
    "blade_plan_choice": "Ce modèle ne propose pas la fréquence choisie. Choisissez une fréquence disponible, l’achat unique ou un autre modèle.",
    "plan_mismatch": "Cette formule ne correspond pas à ce modèle. Vérifiez votre choix avant l’ajout.",
    "with_ritual": "avec le Rituel GroomSkull®",
    "renewal_unknown": "Consultez le montant et les échéances dans les modalités de votre formule.",
    "first_order": "Dès la première commande :",
    "then": "Puis",
    "after_orders": "Après {{ count }} commandes :",
    "renewal_line": "{{ timing }} {{ amount }} par article · {{ cadence }}.",
    "cart_items_one": "{{ count }} article",
    "cart_items_other": "{{ count }} articles",
    "cart_gifts_one": "{{ count }} cadeau",
    "cart_gifts_other": "{{ count }} cadeaux",
    "cart_total": " au total",
    "cart_count_label": "Panier, {{ items }}",
    "cart_count_gift_label": "Panier, {{ items }} et {{ gifts }}",
    "per_shave": "soit ≈ {{ amount }} / rasage",
    "in_stock": "En stock",
    "out_of_stock": "En rupture de stock",
    "close": "Fermer",
    "previous_image": "Image précédente",
    "next_image": "Image suivante",
    "elite_alternative_unique": "Choisissez le Pro 2+ avec la même formule. Coffret premium réservé à l’Elite.",
    "elite_alternative_ritual": "Choisissez le Pro 2+ avec le même Rituel et la même fréquence. Coffret premium réservé à l’Elite.",
    "per_refill": "{{ amount }} / recharge",
    "one_time_price": "{{ amount }} · achat unique",
    "save_today": "−{{ percent }}%",
    "pdp_save_short": "−{{ percent }} %",
    "pdp_cadence_months": "{{ count }} mois",
    "today_per_item": "{{ amount }} aujourd’hui par article",
    "new_tab": " (nouvel onglet)",
    "availability_request": "Demande de disponibilité : {{ title }} / {{ variant }} (variante {{ id }})\n{{ url }}",
    "every_two_months": "Tous les 2 mois",
    "every_three_months": "Tous les 3 mois"
  },
  "en": {
    "shipping_free": "Free delivery in France",
    "shipping_checkout": "Shipping calculated at checkout",
    "cart_render_error": "The cart could not be displayed. Please check your cart.",
    "cart_verify_error": "Your cart could not be verified. Please check it before continuing.",
    "cart_render_check": "Your cart was updated, but its display needs checking. Please review it before checkout.",
    "cart_updating_check": "Your cart is still updating. Please check its contents before checkout.",
    "display_unavailable": "Display unavailable",
    "cart_empty_error": "Your cart is empty. Add an item before checking out.",
    "cart_updating_retry": "Your cart is still updating. Please wait a moment and try again.",
    "line_changed": "This item has changed. Reload your cart before continuing.",
    "cart_change_failed": "A cart update failed. Please correct it or reload your cart.",
    "cart_change_before_checkout": "A cart update failed. Please correct it or reload your cart before checkout.",
    "cart_verify_before_checkout": "Your cart needs to be checked before checkout.",
    "added_check_cart": "Item added. Please review your cart to check its contents.",
    "checkout_timeout": "Checkout is taking longer than expected. Try again shortly or reload the page.",
    "cart_verify_reload": "Your cart could not be verified. Reload it before trying again.",
    "cart_verify_timeout": "Checking your cart is taking too long. Please try again shortly.",
    "checkout_preparing": "Preparing checkout…",
    "cart_updated_check": "Your cart was updated. Please review its contents.",
    "ritual_selected": "The GroomSkull® Ritual selected",
    "one_time": "One-time purchase",
    "one_time_lower": "one-time purchase",
    "added": "Added to cart",
    "add": "Add to cart",
    "adding": "Adding…",
    "removing": "Removing…",
    "cart_pending": "Updating your cart…",
    "error": "Error",
    "ritual_added": "The GroomSkull® Ritual added to cart",
    "cart_label": "Cart",
    "view_cart": "View cart",
    "image_zoom": "Enlarged image",
    "unavailable": "Unavailable",
    "plus_unavailable": "Pro 2+ is also unavailable. Our team can advise you on its restock.",
    "plus_plan_unavailable": "This plan is not available for Pro 2+. Select its card to see the available plans.",
    "choose_frequency": "Choose your frequency",
    "choose_available_frequency": "Choose an available frequency for this model.",
    "blade_plan_choice": "This model does not offer your chosen frequency. Choose an available frequency, a one-time purchase or another model.",
    "plan_mismatch": "This plan does not match this model. Check your selection before adding it.",
    "with_ritual": "with the GroomSkull® Ritual",
    "renewal_unknown": "Check your plan terms for the renewal amount and schedule.",
    "first_order": "From your first order:",
    "then": "Then",
    "after_orders": "After {{ count }} orders:",
    "renewal_line": "{{ timing }} {{ amount }} per item · {{ cadence }}.",
    "cart_items_one": "{{ count }} item",
    "cart_items_other": "{{ count }} items",
    "cart_gifts_one": "{{ count }} gift",
    "cart_gifts_other": "{{ count }} gifts",
    "cart_total": " in total",
    "cart_count_label": "Cart, {{ items }}",
    "cart_count_gift_label": "Cart, {{ items }} and {{ gifts }}",
    "per_shave": "approx. {{ amount }} / shave",
    "in_stock": "In stock",
    "out_of_stock": "Out of stock",
    "close": "Close",
    "previous_image": "Previous image",
    "next_image": "Next image",
    "elite_alternative_unique": "Choose Pro 2+ and keep your purchase option. Premium presentation box exclusive to Elite.",
    "elite_alternative_ritual": "Choose Pro 2+ and keep your Ritual plan and frequency. Premium presentation box exclusive to Elite.",
    "per_refill": "{{ amount }} / refill",
    "one_time_price": "{{ amount }} · one-time purchase",
    "save_today": "−{{ percent }}%",
    "pdp_save_short": "−{{ percent }}%",
    "pdp_cadence_months": "{{ count }} months",
    "today_per_item": "{{ amount }} today per item",
    "new_tab": " (opens in a new tab)",
    "availability_request": "Availability request: {{ title }} / {{ variant }} (variant {{ id }})\n{{ url }}",
    "every_two_months": "Every 2 months",
    "every_three_months": "Every 3 months"
  }
};
  const uiLanguage = () => typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'fr';
  const uiText = (key, values = {}, language = uiLanguage()) => {
    const template = (uiMessages[language] || uiMessages.fr)[key] ?? uiMessages.fr[key] ?? key;
    return template.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, name) => String(values[name] ?? ''));
  };
  const uiCount = (kind, count) => uiText('cart_' + kind + '_' + (count === 1 ? 'one' : 'other'), { count });
  const cadenceDisplay = plan => {
    if (!plan) return '';
    const label = plan.cadenceLabel || plan.name || '';
    if (uiLanguage() !== 'en') return label;
    const verified = verifiedCadence(plan);
    if (verified === 'month:2:2' || /^Tous les 2 mois$/i.test(label)) return uiText('every_two_months');
    if (verified === 'month:3:3' || /^Tous les 3 mois$/i.test(label)) return uiText('every_three_months');
    return label; // Unknown cadence is never invented or silently remapped.
  };


  // Exact Recharge cadence snapshot, 2026-09-09: recharge-plans-reference.json.
  // Both delivery and billing intervals are verified. A renamed or unknown plan does not inherit this mapping.
  const verifiedCadences = {
    '690710937939': ['Pro 2 | Recharge Lames tous les 2 mois', 'month:2:2'],
    '690710970707': ['Pro 2 | Recharge lames tous les 3 mois', 'month:3:3'],
    '690711036243': ['Pro 2+ | Recharge Lames tous les 2 mois', 'month:2:2'],
    '690711069011': ['Pro 2+ | Recharge lames tous les 3 mois', 'month:3:3'],
    '690711134547': ['Pro 2 Elite | Recharge Lames tous les 2 mois', 'month:2:2'],
    '690711101779': ['Pro 2 Elite | Recharge lames tous les 3 mois', 'month:3:3']
  };
  const verifiedCadence = plan => {
    const known = plan && verifiedCadences[String(plan.id)];
    return known && known[0] === plan.name ? known[1] : null;
  };
  const compatiblePlan = (plans, previous) => {
    if (!previous) return null;
    const sameId = plans.find(plan => String(plan.id) === String(previous.id));
    if (sameId) return sameId;
    const cadence = verifiedCadence(previous);
    const matches = cadence ? plans.filter(plan => verifiedCadence(plan) === cadence) : plans.filter(plan => plan.name === previous.name);
    return matches.length === 1 ? matches[0] : null;
  };

  // A remembered estimate destination is valid only in its original Shopify market/currency.
  const deliveryCountryFromStorage = (storage, marketCountry, currency) => {
    try {
      const saved = JSON.parse(storage.getItem('groomskull_delivery_country'));
      return saved && /^[A-Z]{2}$/.test(saved.country || '') && marketCountry && currency &&
        saved.marketCountry === marketCountry && saved.currency === currency ? saved.country : '';
    } catch (_) { return ''; }
  };
  const saveDeliveryCountry = (storage, country, marketCountry, currency) => {
    if (!/^[A-Z]{2}$/.test(country || '') || !marketCountry || !currency) return;
    try { storage.setItem('groomskull_delivery_country', JSON.stringify({country, marketCountry, currency})); } catch (_) {}
  };

  const productShippingMessage = (amount, threshold, eligible, freeText = uiText('shipping_free')) => eligible && Number.isFinite(amount) && Number.isFinite(threshold) && threshold > 0 && amount >= threshold
    ? freeText : uiText('shipping_checkout');
  // Thresholds are rendered by shipping-threshold.liquid. Never convert them in the browser.
  const shippingContextEligible = (data, estimatedCountry, marketCountry, currency) =>
    data.shippingEligible === 'true' && !!marketCountry && !!currency &&
    data.shippingCountry === marketCountry && data.shippingCurrency === currency &&
    (!estimatedCountry || estimatedCountry === marketCountry);
  const renewalCopy = (plan, formatMoney) => {
    if (!plan || !Number.isFinite(plan.renewalPrice) || !Number.isInteger(plan.renewalAfterOrders) || plan.renewalAfterOrders < 0) return '';
    const cadence = cadenceDisplay(plan);
    const timing = plan.renewalAfterOrders === 0 ? uiText('first_order') : plan.renewalAfterOrders === 1 ? uiText('then') : uiText('after_orders', { count: plan.renewalAfterOrders });
    return uiText('renewal_line', { timing, amount: formatMoney(plan.renewalPrice), cadence });
  };
  const purchaseUrl = (currentUrl, sellingPlanId) => {
    const url = new URL(currentUrl);
    if (sellingPlanId) url.searchParams.set('selling_plan', String(sellingPlanId));
    else url.searchParams.delete('selling_plan');
    return url.href;
  };

  async function fetchCartSections(fetcher, pageUrl) {
    const url = new URL(pageUrl);
    url.hash = '';
    url.searchParams.delete('sections');
    url.searchParams.set('section_id', 'cart-drawer');
    // Section rendering is an HTML page request, not the JSON cart API. Preserve preview/locale context.
    const abort = new AbortController(), timer = setTimeout(() => abort.abort(), 8000);
    try {
      const response = await fetcher(url.pathname + url.search, { method: 'GET', cache: 'no-store', credentials: 'same-origin', signal: abort.signal });
      if (!response.ok) throw new Error(uiText('cart_render_error'));
      const html = await response.text();
      if (!html.includes('data-cart-drawer')) throw new Error(uiText('cart_render_error'));
      return { 'cart-drawer': html };
    } finally { clearTimeout(timer); }
  }

  // Compare only server-owned commercial state; no customer details are embedded in the section.
  const cartRenderState = cart => [cart.currency, cart.total_price, cart.total_discount,
    cart.items.map(item => [item.key, item.quantity, item.final_line_price, String(item.selling_plan_allocation?.selling_plan?.id || '')])];
  const bundledCartMatches = (cart, sections) => {
    const html = sections?.['cart-drawer'];
    if (typeof html !== 'string') return false;
    const match = html.match(/<script\b[^>]*\bdata-cart-render-state(?=\s|=|>)[^>]*>([\s\S]*?)<\/script\s*>/i);
    if (!match) return false;
    try { return JSON.stringify(JSON.parse(match[1])) === JSON.stringify(cartRenderState(cart)); } catch (_) { return false; }
  };

  // The queue owns cart intent. Rendering must never turn an accepted add into a failed add.
  function createCartController({ request, replaceVariant = null, readSections = null, beforeCheckout = async () => {}, onState = () => {}, onBusy = () => {}, onError = () => {}, setTimer = setTimeout, clearTimer = clearTimeout, checkoutTimeoutMs = 12000, checkoutRenderTimeoutMs = 1500, setDeadlineTimer = setTimeout, clearDeadlineTimer = clearTimeout }) {
    let chain = Promise.resolve(), operations = 0, checkingOut = false, latestCart = null, displayedSignature = null, checkoutTask = null;
    const scheduled = new Map(), failures = new Map(), identities = new Map(), pendingAdds = new Map();
    let requestedRefreshRevision = 0, verifiedRefreshRevision = 0, refreshTask = null;
    const identity = (item, plan) => JSON.stringify([
      String(item.variant_id || item.id),
      Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b)),
      String(plan === undefined ? (item.selling_plan_allocation?.selling_plan?.id || '') : (plan || ''))
    ]);
    const remember = cart => {
      if (!cart || !Array.isArray(cart.items)) throw new Error(uiText('cart_verify_error'));
      pendingAdds.forEach((attempt, token) => {
        if (!attempt.confirmed) return;
        const quantity = cart.items.filter(item => identity(item) === token).reduce((sum, item) => sum + item.quantity, 0);
        // Once an accepted add is known, a later edit/removal starts a new intent.
        // Never invalidate an unresolved POST merely because the current cart is different.
        if (quantity !== attempt.confirmed.line.quantity) pendingAdds.delete(token);
      });
      cart.items.forEach(item => identities.set(item.key, identity(item)));
      latestCart = cart;
      return cart;
    };
    const busy = () => onBusy({ pending: operations > 0 || scheduled.size > 0 || checkingOut, locked: operations > 0 || checkingOut });
    const read = async () => remember(await request('cart.js'));
    const signature = cart => JSON.stringify([cart.currency, cart.total_price, cart.total_discount, cart.items.map(item => [item.key, item.quantity, item.final_line_price, item.selling_plan_allocation])]);
    const publish = (cart, sections) => {
      try {
        const rendered = onState(cart, sections) !== false;
        displayedSignature = rendered ? signature(cart) : null;
        return rendered;
      } catch (_) { displayedSignature = null; return false; }
    };
    const addUncertain = () => new Error(uiLanguage() === 'en'
      ? 'Please check your cart. Your previous add is still being verified; it has not been repeated.'
      : 'Vérifiez votre panier. Votre ajout précédent reste à confirmer ; il n’a pas été répété.');
    const resolvedAddError = error => Object.assign(error, { cartIntentResolved: true });
    const reconcileAdds = cart => {
      pendingAdds.forEach(attempt => {
        const matches = cart.items.filter(item => identity(item) === attempt.token);
        if (matches.length > 1) return;
        const actual = matches[0]?.quantity || 0;
        if (actual === attempt.expected) attempt.confirmed = { cart, line: matches[0], quantityAdded: attempt.quantity };
        else if (attempt.responseError && actual >= attempt.baseline && actual < attempt.expected) {
          // Shopify can return 422 after adding only the available stock. Read the real delta.
          if (actual === attempt.baseline) attempt.rejected = true;
          else attempt.confirmed = { cart, line: matches[0], quantityAdded: actual - attempt.baseline, notice: attempt.responseError.message };
        } else return;
        // Resolve this exact add only. A failed quantity/plan/variant change remains blocking.
        failures.delete(attempt.key);
      });
      return cart;
    };
    const withDeadline = (promise, milliseconds, message) => new Promise((resolve, reject) => {
      const timer = setDeadlineTimer(() => reject(new Error(message)), milliseconds);
      Promise.resolve(promise).then(resolve, reject).finally(() => clearDeadlineTimer(timer));
    });
    const refreshSnapshot = async knownCart => {
      if (!readSections) {
        const revision = requestedRefreshRevision;
        const cart = reconcileAdds(await read());
        if (publish(cart, cart.sections)) verifiedRefreshRevision = Math.max(verifiedRefreshRevision, revision);
        return cart;
      }
      // A known server response can be the first read. The section snapshot proves what its HTML displays.
      let before = knownCart;
      for (let attempt = 0; attempt < 3; attempt++) {
        if (!before) before = await read();
        const revision = requestedRefreshRevision;
        // Read HTML and cart concurrently. Drain both even on error: a late read must not
        // update remembered identities after this queued operation has already settled.
        const [htmlResult, cartResult] = await Promise.allSettled([
          Promise.resolve().then(() => readSections()),
          Promise.resolve().then(() => read())
        ]);
        if (htmlResult.status === 'rejected') throw htmlResult.reason;
        if (cartResult.status === 'rejected') throw cartResult.reason;
        const sections = htmlResult.value;
        const hasSnapshot = sections?.['cart-drawer']?.includes('data-cart-render-state');
        // Legacy HTML without its own snapshot still requires a read after rendering.
        const after = hasSnapshot ? cartResult.value : await read();
        const stable = signature(before) === signature(after);
        before = after;
        if (!stable || (sections?.['cart-drawer']?.includes('data-cart-render-state') && !bundledCartMatches(after, sections))) continue;
        reconcileAdds(after);
        if (!sections?.['cart-drawer'] || !publish(after, sections)) throw new Error(uiText('cart_render_check'));
        verifiedRefreshRevision = Math.max(verifiedRefreshRevision, revision);
        return after;
      }
      throw new Error(uiText('cart_updating_check'));
    };
    const refreshNotification = async () => {
      // An unchanged app notification needs a fresh read, not another identical HTML render.
      // Capture before the read: an event arriving during it still needs the next pass.
      const revision = requestedRefreshRevision;
      const cart = reconcileAdds(await read());
      if (!failures.has('refresh') && displayedSignature !== null && signature(cart) === displayedSignature) {
        verifiedRefreshRevision = Math.max(verifiedRefreshRevision, revision);
        return cart;
      }
      return refreshSnapshot(cart);
    };
    const renderMutation = async data => {
      // Bundled HTML is useful only when it exactly matches a fresh cart read, including gifts and plans.
      const revision = requestedRefreshRevision;
      const after = reconcileAdds(await read());
      if (bundledCartMatches(after, data.sections) && publish(after, data.sections)) {
        verifiedRefreshRevision = Math.max(verifiedRefreshRevision, revision);
        return after;
      }
      return refreshSnapshot(after);
    };
    const checkoutSnapshot = async () => {
      // Checkout depends on verified server data and successful gift preparation, not on cosmetic HTML availability.
      for (let attempt = 0; attempt < 3; attempt++) {
        const before = await read();
        let sections = null;
        if (readSections && signature(before) !== displayedSignature) {
          try { sections = await withDeadline(readSections(), checkoutRenderTimeoutMs, uiText('display_unavailable')); } catch (_) {}
        }
        const after = await read();
        if (signature(before) !== signature(after)) continue;
        if (!after.items.length) throw new Error(uiText('cart_empty_error'));
        reconcileAdds(after);
        if (sections?.['cart-drawer']) publish(after, sections);
        else if (!readSections) publish(after, after.sections);
        return after;
      }
      throw new Error(uiText('cart_updating_retry'));
    };
    const locate = (cart, key) => {
      let index = cart.items.findIndex(item => item.key === key);
      if (index < 0 && identities.has(key)) {
        const matches = cart.items.map((item, i) => identity(item) === identities.get(key) ? i : -1).filter(i => i >= 0);
        if (matches.length === 1) index = matches[0];
      }
      if (index < 0) throw new Error(uiText('line_changed'));
      return { item: cart.items[index], line: index + 1 };
    };
    const enqueue = (key, fn) => {
      operations++; busy();
      const result = chain.then(fn).then(value => { failures.delete(key); return value; }, error => {
        if (error.cartIntentResolved) failures.delete(key); else failures.set(key, error);
        onError(error); throw error;
      }).finally(() => { operations--; busy(); });
      chain = result.then(() => {}, () => {});
      return result;
    };
    const cancelQuantity = key => {
      const pending = scheduled.get(key);
      if (pending) { clearTimer(pending.timer); scheduled.delete(key); }
    };
    const changeQuantity = (key, quantity, allowDirectRemove = false) => {
      cancelQuantity(key);
      return enqueue('quantity:' + key, async () => {
        // Removal targets an exact server key, never a variant or positional line. Only
        // skip the first GET for a snapshot already verified and displayed by this queue.
        const directRemove = allowDirectRemove && quantity === 0 && typeof key === 'string' && key.includes(':') &&
          latestCart && displayedSignature === signature(latestCart) && !failures.size && !pendingAdds.size &&
          requestedRefreshRevision === verifiedRefreshRevision && latestCart.items.some(item => item.key === key);
        const cart = directRemove ? latestCart : await read();
        const { item } = locate(cart, key);
        let response;
        try { response = await request('cart/change.js', { id: item.key, quantity, sections: 'cart-drawer' }); }
        catch (error) {
          // Shopify documents this exact 400 as an absent key. Other 400s (including
          // section-rendering errors), network errors and ambiguous POSTs must not retry.
          if (!directRemove || error.cartResponseStatus !== 400 || error.message !== 'no valid id or line parameter') throw error;
          const fresh = await read();
          const { item: current } = locate(fresh, key);
          response = await request('cart/change.js', { id: current.key, quantity: 0, sections: 'cart-drawer' });
        }
        const updated = remember(response);
        if (readSections) return renderMutation(updated);
        publish(updated, updated.sections);
        return updated;
      });
    };
    const flushQuantities = () => {
      const pending = Array.from(scheduled.entries());
      pending.forEach(([key, value]) => { changeQuantity(key, value.quantity).catch(() => {}); });
    };
    return {
      changeQuantity,
      setBladeQuantity(source, quantity) {
        if (!source || Number(source.product_id) !== 8581948703059 || source.selling_plan_allocation ||
            !Number.isInteger(quantity) || quantity < 1 || quantity > 4 || quantity <= source.quantity) {
          return Promise.reject(new Error(uiText('line_changed')));
        }
        flushQuantities();
        identities.set(source.key, identity(source));
        return enqueue('quantity:' + source.key, async () => {
          const cart = await read();
          const {item} = locate(cart, source.key);
          if (identity(item) !== identity(source) || item.quantity !== source.quantity || item.selling_plan_allocation || item.final_line_price <= 0) throw new Error(uiText('line_changed'));
          let updated;
          try { updated = remember(await request('cart/change.js', {id:item.key, quantity, sections:'cart-drawer'})); }
          catch (error) {
            const actual = await read();
            const matches = actual.items.filter(line => identity(line) === identity(source));
            if (matches.length !== 1 || matches[0].quantity !== quantity) throw error;
            updated = actual; // Accepted write with a lost response: never send a second change.
          }
          if (readSections) return renderMutation(updated);
          publish(updated, updated.sections);return updated;
        });
      },
      refresh() {
        requestedRefreshRevision++;
        if (refreshTask) return refreshTask;
        const task = enqueue('refresh', async () => {
          try {
            // App event bursts share one task. A mutation may already have verified those events.
            for (let pass = 0; pass < 3; pass++) {
              if (latestCart && verifiedRefreshRevision >= requestedRefreshRevision) return latestCart;
              const cart = await refreshNotification();
              if (verifiedRefreshRevision >= requestedRefreshRevision) return cart;
            }
            throw new Error(uiText('cart_updating_check'));
          } finally {
            // The body can no longer drain notifications. A late event needs its own queued task,
            // even while enqueue's promise handlers are still settling this one.
            if (refreshTask === task) refreshTask = null;
          }
        });
        refreshTask = task;
        const clear = () => { if (refreshTask === task) refreshTask = null; };
        task.then(clear, clear);
        return task;
      },
      scheduleQuantity(key, quantity) {
        cancelQuantity(key);
        scheduled.set(key, { quantity, timer: setTimer(() => { changeQuantity(key, quantity).catch(() => {}); }, 330) });
        busy();
      },
      remove(key) {
        cancelQuantity(key);
        flushQuantities();
        return changeQuantity(key, 0, true);
      },
      changeVariant(key, variantId, variants) {
        flushQuantities();
        return enqueue('variant:' + key, async () => {
          if (!replaceVariant) throw new Error(uiText('cart_change_failed'));
          const cart = await read();
          const { item } = locate(cart, key);
          let replaced;
          try {
            replaced = remember(await replaceVariant({ request, cart, key: item.key, variantId, variants }));
          } catch (error) {
            if (error.cartReconciled && error.cart) {
              remember(error.cart);
              try { await refreshSnapshot(); } catch (_) {}
              onError(error);
              return { changed: false, reconciled: true, message: error.message };
            }
            try { await refreshSnapshot(); } catch (_) {}
            throw error;
          }
          try { return await refreshSnapshot(); }
          catch (_) {
            // The replacement was verified. A rendering failure must not retry that write.
            onError(new Error(uiText('cart_updated_check')));
            return { changed: true, cart: replaced, notice: uiText('cart_updated_check') };
          }
        });
      },
      changePlan(key, plan, sourceItem = null, splitOne = false) {
        flushQuantities();
        return enqueue('plan:' + key, async () => {
          if (Array.from(failures.keys()).some(failed => failed !== 'plan:' + key && failed !== 'refresh')) throw new Error(uiText('cart_change_failed'));
          if (sourceItem && !identities.has(key)) identities.set(key, identity(sourceItem));
          const cart = await read();
          const { item, line } = locate(cart, key);
          const oldIdentity = identity(item), nextIdentity = identity(item, plan);
          if (splitOne && oldIdentity !== nextIdentity) {
            if (item.quantity < 2 || item.quantity !== Number(sourceItem?.quantity)) throw new Error(uiText('line_changed'));
            const count = (snapshot, id) => snapshot.items.filter(entry => identity(entry) === id).reduce((sum, entry) => sum + entry.quantity, 0);
            const oldCount = count(cart, oldIdentity), nextCount = count(cart, nextIdentity);
            const completed = snapshot => count(snapshot, oldIdentity) === oldCount - 1 && count(snapshot, nextIdentity) === nextCount + 1;
            try {
              await request('cart/change.js', {line, quantity:item.quantity - 1});
              const reduced = await read();
              if (count(reduced, oldIdentity) !== oldCount - 1 || count(reduced, nextIdentity) !== nextCount) throw new Error(uiText('line_changed'));
              const addition = {id:Number(item.variant_id || item.id), quantity:1, properties:item.properties || {}};
              if (plan) addition.selling_plan = Number(plan);
              await request('cart/add.js', {items:[addition]});
              if (!completed(await read())) throw new Error(uiText('cart_verify_error'));
            } catch (error) {
              const actual = await read();
              if (!completed(actual)) {
                // Restore only an unambiguous reduction with no accepted addition.
                const sources = actual.items.filter(entry => identity(entry) === oldIdentity);
                if (sources.length === 1 && count(actual, oldIdentity) === oldCount - 1 && count(actual, nextIdentity) === nextCount) {
                  await request('cart/change.js', {id:sources[0].key, quantity:sources[0].quantity + 1});
                }
                try { await refreshSnapshot(); } catch (_) {}
                throw error;
              }
            }
            // The split is confirmed. A display failure must not repeat the addition.
            const confirmed = latestCart;
            try { return await refreshSnapshot(); }
            catch (_) { publish(confirmed, confirmed.sections); onError(new Error(uiText('cart_updated_check'))); return confirmed; }
          }
          const updated = remember(await request('cart/change.js', { line, quantity: item.quantity, selling_plan: plan ? Number(plan) : null, sections: 'cart-drawer' }));
          identities.forEach((value, alias) => { if (value === oldIdentity) identities.set(alias, nextIdentity); });
          identities.set(key, nextIdentity);
          if (readSections) return renderMutation(updated);
          publish(updated, updated.sections);
          return updated;
        });
      },
      add(id, quantity = 1, sellingPlan = null, properties = null) {
        if (!Number.isSafeInteger(Number(id)) || Number(id) <= 0 || !Number.isSafeInteger(quantity) || quantity < 1 ||
            (sellingPlan && (!Number.isSafeInteger(Number(sellingPlan)) || Number(sellingPlan) <= 0))) {
          return Promise.reject(new Error(uiText('cart_change_failed')));
        }
        flushQuantities();
        const item = { id: Number(id), quantity };
        if (properties) item.properties = { ...properties };
        if (sellingPlan) item.selling_plan = Number(sellingPlan);
        const token = identity(item, sellingPlan), key = 'add:' + token;
        return enqueue(key, async () => {
          let data, acceptedQuantity = quantity, addNotice = '';
          let previous = pendingAdds.get(token);
          if (previous?.confirmed) {
            // The line can also have been changed by an app or another tab since confirmation.
            try { await read(); } catch (_) { throw resolvedAddError(addUncertain()); }
            previous = pendingAdds.get(token);
          }
          if (previous) {
            // A second click resolves the first intent, never sends a second ambiguous POST.
            if (!previous.confirmed && !previous.rejected) {
              try { reconcileAdds(await read()); } catch (_) { throw addUncertain(); }
            }
            if (previous.rejected) { pendingAdds.delete(token); throw resolvedAddError(previous.responseError); }
            if (!previous.confirmed) throw addUncertain();
            data = { items: [previous.confirmed.line] };
            acceptedQuantity = previous.confirmed.quantityAdded;
            addNotice = previous.confirmed.notice || (uiLanguage() === 'en' ? 'Your previous add is confirmed. No extra item was added.' : 'Votre ajout précédent est confirmé. Aucun article supplémentaire n’a été ajouté.');
            pendingAdds.delete(token);
          } else {
            if (Array.from(pendingAdds.values()).some(attempt => !attempt.confirmed && !attempt.rejected)) throw resolvedAddError(addUncertain());
            let before;
            try { before = await read(); } catch (error) { throw resolvedAddError(error); }
            const baseline = before.items.filter(line => identity(line) === token).reduce((sum, line) => sum + line.quantity, 0);
            const attempt = { key, token, baseline, quantity, expected: baseline + quantity, confirmed: null, rejected: false, responseError: null };
            try { data = await request('cart/add.js', { items: [item], sections: 'cart-drawer' }); }
            catch (error) {
              if (error.cartResponseStatus >= 400 && error.cartResponseStatus < 500) attempt.responseError = error;
              pendingAdds.set(token, attempt);
              try { reconcileAdds(await read()); } catch (_) { /* Keep the pending intent until a later verified read. */ }
              if (attempt.rejected) { pendingAdds.delete(token); throw resolvedAddError(error); }
              if (!attempt.confirmed) throw addUncertain();
              data = { items: [attempt.confirmed.line] };
              acceptedQuantity = attempt.confirmed.quantityAdded;
              addNotice = attempt.confirmed.notice || '';
              pendingAdds.delete(token);
            }
          }
          let cart = null, rendered = false;
          try {
            if (readSections) { cart = await renderMutation(data); rendered = true; }
            else { cart = await read(); rendered = publish(cart, data.sections); }
          } catch (_) { /* The write already succeeded. Never retry it here. */ }
          return { data, cart, quantityAdded: acceptedQuantity, notice: addNotice || (cart && rendered ? '' : uiText('added_check_cart')) };
        });
      },
      addMany(items) {
        if (!Array.isArray(items) || items.length !== 2 || new Set(items.map(item => Number(item.id))).size !== 2 ||
            items.some(item => !Number.isSafeInteger(Number(item.id)) || Number(item.id) <= 0 || item.quantity !== 1 || item.selling_plan)) {
          return Promise.reject(new Error(uiText('cart_change_failed')));
        }
        const additions = items.map(item => ({id:Number(item.id),quantity:1,properties:{...item.properties}}));
        flushQuantities();
        return enqueue('duo:' + additions.map(item => item.id).join(','), async () => {
          const before = await read();
          const count = (cart, addition) => cart.items.filter(item => identity(item) === identity(addition)).reduce((sum,item) => sum + item.quantity,0);
          const counts = additions.map(item => count(before,item));
          let data;
          try { data = await request('cart/add.js', {items:additions,sections:'cart-drawer'}); }
          catch (error) {
            // Reconcile a partial/ambiguous response, never repeat a potentially accepted write.
            const actual = await read();
            if (additions.every((item,index) => count(actual,item) === counts[index] + 1)) {
              data = {items:actual.items.filter(item => additions.some(addition => identity(item) === identity(addition)))};
            } else {
              try { await refreshSnapshot(); } catch (_) {}
              if (additions.some((item,index) => count(actual,item) > counts[index])) {
                return {data:{items:[]},cart:actual,partial:true,notice:uiLanguage() === 'en' ? 'Only part of the duo was added. Please check your cart.' : 'Le duo a été ajouté en partie. Vérifiez votre panier.'};
              }
              throw error;
            }
          }
          let cart = null, rendered = false;
          try {
            if (readSections) { cart = await renderMutation(data); rendered = true; }
            else { cart = await read(); rendered = publish(cart,data.sections); }
          } catch (_) { /* The add succeeded; a display failure is not an invitation to add again. */ }
          return {data,cart,notice:cart && rendered ? '' : uiText('added_check_cart')};
        });
      },
      checkout() {
        if (!checkoutTask) {
          flushQuantities();
          checkingOut = true; busy();
          checkoutTask = (async () => {
            let barrier;
            do { barrier = chain; await barrier; } while (barrier !== chain);
            if (Array.from(pendingAdds.values()).some(attempt => !attempt.confirmed && !attempt.rejected)) {
              await enqueue('refresh', async () => reconcileAdds(await read()));
            }
            if (Array.from(failures.keys()).some(failed => failed !== 'refresh')) throw new Error(uiText('cart_change_before_checkout'));
            await beforeCheckout();
            for (let attempt = 0; attempt < 3; attempt++) {
              do { barrier = chain; await barrier; } while (barrier !== chain);
              const verification = enqueue('refresh', checkoutSnapshot);
              const verifiedBarrier = chain;
              const cart = await verification;
              do { barrier = chain; await barrier; } while (barrier !== chain);
              if (Array.from(failures.keys()).some(failed => failed !== 'refresh')) throw new Error(uiText('cart_verify_before_checkout'));
              if (verifiedBarrier === chain) return cart;
            }
            throw new Error(uiText('cart_updating_retry'));
          })().finally(() => { checkingOut = false; checkoutTask = null; busy(); });
        }
        // A timeout releases the caller, never the in-flight app/mutation. A retry joins the same task.
        return withDeadline(checkoutTask, checkoutTimeoutMs, uiText('checkout_timeout'));
      }
    };
  }
  // Presentation only: keep feedback across section/upsell replacements, never assume a write succeeded.
  function createCartActionFeedback({ controls, tokenFor, status }) {
    const actions = new Map(), held = new Map();
    let pending = false;
    const render = () => {
      held.forEach((saved, control) => { if (!control.isConnected) held.delete(control); });
      controls().forEach(control => {
        const message = actions.get(tokenFor(control));
        if (message) {
          if (!held.has(control)) held.set(control, { html: control.innerHTML, disabled: control.disabled, busy: control.getAttribute('aria-busy') });
          control.disabled = true; control.setAttribute('aria-busy', 'true'); control.setAttribute('data-cart-feedback', '');
          if (control.textContent !== message) control.textContent = message;
        } else if (held.has(control)) {
          const saved = held.get(control); held.delete(control);
          control.innerHTML = saved.html;
          control.disabled = saved.disabled || control.hasAttribute('data-cart-locked');
          if (saved.busy === null) control.removeAttribute('aria-busy'); else control.setAttribute('aria-busy', saved.busy);
          control.removeAttribute('data-cart-feedback');
        }
      });
      const box = status();
      if (box) {
        const message = Array.from(actions.values()).at(-1) || (pending ? uiText('cart_pending') : '');
        if (box.textContent !== message) box.textContent = message;
        box.hidden = !message;
      }
    };
    return {
      render,
      setBusy(value) { pending = value; render(); },
      begin(token, message) {
        if (actions.has(token)) { render(); return null; }
        actions.set(token, message); render();
        return () => { actions.delete(token); render(); };
      }
    };
  }
  // A refreshed cart may reorder or remove lines. Never restore focus to another item by position.
  const cartFocusTarget = (lines, previous) => {
    if (!previous?.key || !previous.ctrl) return null;
    const line = lines.find(candidate => candidate.dataset.key === previous.key);
    return line?.querySelector(previous.ctrl) || null;
  };
  function createCartFocusManager(drawer, doc) {
    const controls = ['[data-qty-up]', '[data-qty-down]', '[data-qty-input]', '[data-remove]', '[data-sub-on]', '[data-sub-off]'];
    let intent = null, previousElement = null, blocked = false, locked = false, viewport = null;
    const identities = new Map();
    let currentItems = [];
    // Observe complete server carts only. This metadata never changes a transaction or its payload.
    const identity = item => JSON.stringify([String(item.product_id || ''), String(item.variant_id || item.id), Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b)), String(item.selling_plan_allocation?.selling_plan?.id || '')]);
    const remember = cart => {
      if (!cart || !Array.isArray(cart.items) || !Number.isFinite(cart.item_count)) return;
      currentItems = cart.items.map(item => ({ key: item.key, identity: identity(item) }));
      currentItems.forEach(item => identities.set(item.key, item.identity));
    };
    const resolveKey = key => {
      if (currentItems.some(item => item.key === key)) return key;
      const token = identities.get(key);
      const matches = token ? currentItems.filter(item => item.identity === token) : [];
      return matches.length === 1 ? matches[0].key : key;
    };
    const clear = () => { intent = null; previousElement = null; blocked = true; viewport = null; };
    const capture = element => {
      if (!element || element === doc.body || element === doc.documentElement) return;
      if (!drawer.contains(element)) { clear(); return; }
      const line = element.closest?.('.cart-line');
      const ctrl = controls.find(selector => element.matches?.(selector));
      const fixed = ['[data-cart-close]', '[data-checkout]'].find(selector => element.matches?.(selector));
      if (line?.dataset.key && ctrl) intent = { key: line.dataset.key, ctrl };
      else if (fixed) intent = { fixed };
      else { clear(); return; }
      previousElement = element; blocked = false;
    };
    const beforeChange = () => {
      // Locking can blur a disabled button. Keep the intent captured before disabling it.
      if (!locked && !blocked) capture(doc.activeElement);
      const scroll = drawer.querySelector('[data-cart-scroll]');
      if (!scroll) return;
      const bounds = scroll.getBoundingClientRect?.();
      const anchors = bounds ? Array.from(drawer.querySelectorAll('.cart-line')).map(line => {
        const rect = line.getBoundingClientRect?.();
        return rect && rect.bottom > bounds.top && rect.top < bounds.bottom ? { key: line.dataset.key, offset: rect.top - bounds.top } : null;
      }).filter(Boolean) : [];
      viewport = { top: scroll.scrollTop, anchors };
    };
    const restoreViewport = () => {
      if (!viewport) return;
      const saved = viewport; viewport = null;
      const scroll = drawer.querySelector('[data-cart-scroll]');
      if (!scroll) return;
      scroll.scrollTop = saved.top;
      const lines = Array.from(drawer.querySelectorAll('.cart-line'));
      for (const anchor of saved.anchors) {
        const line = lines.find(candidate => candidate.dataset.key === resolveKey(anchor.key));
        const rect = line?.getBoundingClientRect?.(), bounds = scroll.getBoundingClientRect?.();
        if (!rect || !bounds) continue;
        scroll.scrollTop += rect.top - bounds.top - anchor.offset;
        break;
      }
      // Browser also clamps this; keep the fallback deterministic when the cart became shorter.
      scroll.scrollTop = Math.max(0, Math.min(scroll.scrollTop, Math.max(0, scroll.scrollHeight - scroll.clientHeight)));
    };
    const restore = () => {
      if (!drawer.classList.contains('is-open') && !drawer.hasAttribute('data-cart-page')) return;
      restoreViewport();
      if (blocked || locked || !intent) return;
      const active = doc.activeElement;
      // A real user focus destination always wins over the remembered cart control.
      if (active && active !== doc.body && active !== doc.documentElement && active !== previousElement && active.isConnected !== false) { clear(); return; }
      const target = intent.fixed ? drawer.querySelector(intent.fixed)
        : cartFocusTarget(Array.from(drawer.querySelectorAll('.cart-line')), { ...intent, key: resolveKey(intent.key) });
      const destination = target || drawer.querySelector('[data-cart-close]') || (drawer.hasAttribute('data-cart-page') ? drawer : null);
      if (!destination || destination.disabled) return;
      destination.focus({ preventScroll: true });
      capture(destination);
    };
    return {
      clear, capture, beforeChange, restore, remember,
      setLocked(value) { if (value && !locked && !blocked) capture(doc.activeElement); locked = value; },
      pointer(target) {
        const control = target?.closest?.(controls.concat('[data-cart-close]', '[data-checkout]').join(','));
        if (control && drawer.contains(control)) capture(control); else clear();
      }
    };
  }
  // Run the actual cart controller in Node tests without installing browser globals.
  if (typeof document === 'undefined' && typeof module !== 'undefined') {
    module.exports = { createCartActionFeedback, uiText, bundledCartMatches, createCartController, compatiblePlan, fetchCartSections, productShippingMessage, shippingContextEligible, renewalCopy, purchaseUrl, cartFocusTarget, createCartFocusManager };
    return;
  }
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const route = path => (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/') + path;
  const track = (event, ecommerce) => {
    try { (window.dataLayer = window.dataLayer || []).push({ ecommerce: null }, { event, ecommerce }); } catch (_) {}
  };
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency', currency: window.Shopify?.currency?.active || 'EUR'
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' ' + (window.Shopify?.currency?.active || 'EUR'); }
  };
  const deliveryCountryKey = 'groomskull_delivery_country';
  const selectedDeliveryCountry = () => {
    const country = document.documentElement.dataset.deliveryCountry;
    if (country) return country;
    const marketCountry = document.documentElement.dataset.marketCountry || '';
    try { return deliveryCountryFromStorage(sessionStorage, marketCountry, window.Shopify?.currency?.active) || marketCountry; } catch (_) { return marketCountry; }
  };
  // Progressive enhancement: select once; native Shopify submission preserves market rules.
  const initLocalization = () => document.querySelectorAll('.gs-localization__form').forEach(form => {
    if (form.dataset.instantLocalization) return;
    form.dataset.instantLocalization = 'true';
    const button = form.querySelector('button[type="submit"]');
    if (button) { button.hidden = true; button.style.display = 'none'; }
    form.addEventListener('change', event => {
      if (!event.target.matches('select') || form.dataset.submitting) return;
      form.dataset.submitting = 'true';
      form.setAttribute('aria-busy', 'true');
      form.requestSubmit();
    });
  });
  initLocalization();
  document.addEventListener('shopify:section:load', initLocalization);
  // Shopify owns the market change. Preserve the same-origin purchase URL through its native form.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches?.('.gs-localization__form')) return;
    const returnInput = form.querySelector('input[name="return_to"]');
    if (returnInput) {
      const current = new URL(window.location.pathname + window.location.search, window.location.origin);
      returnInput.value = current.origin === window.location.origin
        ? current.pathname + current.search : '/';
    }
    try { sessionStorage.removeItem(deliveryCountryKey); } catch (_) {}
  });
  const updateCartShipping = () => {
    const country = selectedDeliveryCountry();
    const market = document.documentElement.dataset.marketCountry;
    const currency = window.Shopify?.currency?.active;
    $$('[data-cart-shipping]').forEach(label => {
      const eligible = shippingContextEligible(label.dataset, country, market, currency);
      label.textContent = eligible && label.dataset.shippingFree === 'true' ? label.dataset.shippingFreeText : productShippingMessage(Number(label.dataset.shippingAmount), Number(label.dataset.shippingThreshold), eligible, label.dataset.shippingFreeText);
    });
    $$('[data-free-ship]').forEach(progress => { progress.hidden = !shippingContextEligible(progress.dataset, country, market, currency); });
  };
  document.addEventListener('delivery:country:change', event => {
    const country = event.detail?.country || event.target.dataset?.deliveryCountry;
    if (!/^[A-Z]{2}$/.test(country || '')) return;
    document.documentElement.dataset.deliveryCountry = country;
    try { saveDeliveryCountry(sessionStorage, country, document.documentElement.dataset.marketCountry, window.Shopify?.currency?.active); } catch (_) {}
    updateCartShipping();
  });
  updateCartShipping();

  /* ---------- Reveal on scroll ---------- */
  const io = ('IntersectionObserver' in window)
    ? new IntersectionObserver((entries) => {
        entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' })
    : null;
  const observeReveals = (root = document) => {
    if (!io) { $$('[data-reveal]', root).forEach(el => el.classList.add('is-in')); return; }
    $$('[data-reveal]', root).forEach(el => {
      try { el.classList.add('reveal-ready'); io.observe(el); }
      catch (_) { el.classList.remove('reveal-ready'); el.classList.add('is-in'); }
    });
  };
  observeReveals();

  /* ---------- Header hide on scroll + theme switch ---------- */
  const header = $('[data-header]');
  if (header) {
    let lastY = 0;
    const onScroll = () => {
      const y = window.scrollY;
      if (y > 200 && y > lastY) header.classList.add('is-hidden');
      else header.classList.remove('is-hidden');
      if (y > 40 && header.dataset.theme === 'dark') header.dataset.theme = 'light';
      else if (y <= 40 && header.dataset.initTheme === 'dark') header.dataset.theme = 'dark';
      lastY = y;
    };
    header.dataset.initTheme = header.dataset.theme;
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Overlay helpers ---------- */
  let activeModal = null;
  let coordinateReviewModal = () => {};
  let coordinateGiftModal = () => {};
  let refreshProductAction = () => {};
  const visibleGiftDialog = () => {
    const popup = $('#freegifts-main-popup-container');
    return popup?.isConnected && popup.classList.contains('sca-is-visible-fg') &&
      popup.getClientRects().length && getComputedStyle(popup).display !== 'none' &&
      getComputedStyle(popup).visibility !== 'hidden' ? $('.bogos-gift-slider-modal', popup) : null;
  };
  const modalInert = new Map();
  const releaseModal = element => {
    if (activeModal !== element) return;
    modalInert.forEach((wasInert, node) => { if (!wasInert) node.removeAttribute('inert'); });
    modalInert.clear(); activeModal = null;
    refreshProductAction();
  };
  const focusModal = (element, initial, preventScroll = true) => {
    if (!element) return;
    if (activeModal) releaseModal(activeModal);
    activeModal = element;
    element.setAttribute('role', 'dialog'); element.setAttribute('aria-modal', 'true'); element.setAttribute('tabindex', '-1');
    // Inert siblings at every ancestor level, including Shopify section wrappers.
    for (let branch = element; branch && branch !== document.body; branch = branch.parentElement) {
      if (!branch.parentElement) break;
      Array.from(branch.parentElement.children).forEach(sibling => {
        if (sibling === branch || sibling.matches('script, style, [data-overlay]')) return;
        modalInert.set(sibling, sibling.hasAttribute('inert')); sibling.setAttribute('inert', '');
      });
    }
    (initial || element).focus({ preventScroll });
    refreshProductAction();
    queueMicrotask(() => { coordinateReviewModal(); coordinateGiftModal(); });
  };
  document.addEventListener('keydown', event => {
    if (event.key !== 'Tab' || !activeModal) return;
    const nodes = $$('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', activeModal)
      .filter(node => !node.closest('[hidden], [inert]') && node.getClientRects().length > 0);
    const first = nodes[0], last = nodes[nodes.length - 1];
    if (!first) { event.preventDefault(); activeModal.focus(); return; }
    if (!activeModal.contains(document.activeElement) || (event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last)) {
      event.preventDefault(); (event.shiftKey ? last : first).focus();
    }
  });
  const overlay = $('[data-overlay]');
  let overlayTimer, overlayRevision = 0;
  const openOverlay = () => { const revision = ++overlayRevision; clearTimeout(overlayTimer); if (overlay) { overlay.hidden = false; requestAnimationFrame(() => { if (revision === overlayRevision) overlay.classList.add('is-active'); }); } document.body.classList.add('no-scroll'); };
  const closeOverlay = () => { overlayRevision += 1; if (overlay) { overlay.classList.remove('is-active'); overlayTimer = setTimeout(() => overlay.hidden = true, 350); } document.body.classList.remove('no-scroll'); refreshProductAction(); };

  /* ---------- Mobile nav ---------- */
  const mnav = $('[data-mobile-nav]');
  let mnavOpener = null, mnavOpen = false, cartOpen = false;
  const openMNav = () => { if (!mnav || mnavOpen) return; if (cartOpen) closeCart(); mnavOpen = true; mnavOpener = document.activeElement; mnav.classList.add('is-open'); mnav.setAttribute('aria-hidden', 'false'); mnav.removeAttribute('inert'); $('[data-mobile-open]')?.setAttribute('aria-expanded', 'true'); openOverlay(); focusModal(mnav, $('[data-mobile-close]', mnav)); };
  const closeMNav = (restoreFocus = true) => { if (!mnavOpen) return; mnavOpen = false; releaseModal(mnav); mnav?.classList.remove('is-open'); mnav?.setAttribute('aria-hidden', 'true'); mnav?.setAttribute('inert', ''); $('[data-mobile-open]')?.setAttribute('aria-expanded', 'false'); if (!cartOpen) closeOverlay(); if (restoreFocus && mnavOpener?.isConnected) mnavOpener.focus(); mnavOpener = null; };
  $('[data-mobile-open]')?.addEventListener('click', openMNav);
  $$('[data-mobile-close]').forEach(b => b.addEventListener('click', closeMNav));

  /* ---------- Cart drawer ---------- */
  const drawer = $('[data-cart-drawer]');
  const collapsedRituelOffers = new Set();
  try { JSON.parse(sessionStorage.getItem('gs-rituel-collapsed') || '[]').forEach(id => collapsedRituelOffers.add(String(id))); } catch (_) {}
  const restoreRituelOffers = () => drawer?.querySelectorAll('[data-offer-variant]').forEach(offer => {
    offer.classList.toggle('is-collapsed', collapsedRituelOffers.has(offer.dataset.offerVariant));
  });
  const collapseRituelOffer = id => {
    collapsedRituelOffers.add(String(id));
    try { sessionStorage.setItem('gs-rituel-collapsed', JSON.stringify([...collapsedRituelOffers])); } catch (_) {}
    restoreRituelOffers();
  };
  restoreRituelOffers();
  const cartPage = drawer?.hasAttribute('data-cart-page');
  const cartFocus = drawer ? createCartFocusManager(drawer, document) : null;
  document.addEventListener('focusin', event => cartFocus?.capture(event.target));
  document.addEventListener('pointerdown', event => cartFocus?.pointer(event.target), true);
  let cartOpener = null;
  // A requested dismissal wins over completions of adds already in flight.
  let cartDismissRevision = 0;
  const alignCartEdge = () => {
    if (!drawer || cartPage || !cartOpen) return;
    drawer.style.right = '0px';
    if (window.matchMedia('(min-width:768px)').matches) {
      const gap = document.documentElement.getBoundingClientRect().right - window.innerWidth;
      drawer.style.right = `${Math.min(0, gap)}px`;
    }
  };
  window.addEventListener('resize', alignCartEdge, { passive: true });
  const openCart = () => { if (visibleGiftDialog()) { coordinateGiftModal(); return; } if (!drawer || cartOpen) return; if (cartPage) { drawer.scrollIntoView({ behavior: 'smooth', block: 'start' }); drawer.focus({ preventScroll: true }); return; } if (mnavOpen) closeMNav(); cartOpen = true; cartOpener = document.activeElement; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); drawer.removeAttribute('inert'); openOverlay(); alignCartEdge(); focusModal(drawer, $('[data-cart-close]', drawer)); };
  const closeCart = (restoreFocus = true) => { cartDismissRevision += 1; if (!cartOpen) return; cartOpen = false; cartFocus?.clear(); releaseModal(drawer); drawer?.classList.remove('is-open'); drawer?.setAttribute('aria-hidden', 'true'); drawer?.setAttribute('inert', ''); if (!mnavOpen) closeOverlay(); if (restoreFocus && cartOpener?.isConnected) cartOpener.focus({ preventScroll: true }); cartOpener = null; };
  const cartActionAllowed = control => !!control &&
    (!activeModal || activeModal.contains(control)) &&
    (!cartOpen || drawer?.contains(control)) &&
    (!mnavOpen || mnav?.contains(control)) &&
    !control.closest('[inert]');
  const openCartAfterAdd = revision => {
    if (revision === cartDismissRevision) openCart();
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-page-link]')) return;
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
    { const cc = e.target.closest('[data-cart-close]'); if (cc) { if (!cc.matches('a[href]')) e.preventDefault(); closeCart(); } }
    const checkout = e.target.closest('a[data-checkout]');
    if (checkout) { e.preventDefault(); proceedToCheckout(checkout.href); }
  });
  overlay?.addEventListener('click', () => { closeCart(); closeMNav(); });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (activeModal?.matches('.bogos-gift-slider-modal')) {
      const close = $('.bogos-slider-close-btn', activeModal);
      if (close) { e.preventDefault(); close.click(); }
      return;
    }
    closeCart(); closeMNav();
  });

  /* M: coordinate the provider-owned review form without opening or submitting it. */
  {
    let currentReview = null, reviewOpener = null, ownsReviewScrollLock = false;
    let observedReviews = [], scheduledReviewFrame = 0;
    const reviewStyleObserver = new MutationObserver(() => scheduleReviewSync());
    const scheduleReviewSync = () => {
      if (scheduledReviewFrame) return;
      scheduledReviewFrame = requestAnimationFrame(() => { scheduledReviewFrame = 0; coordinateReviewModal(); });
    };
    coordinateReviewModal = () => {
      if (activeModal?.matches('.bogos-gift-slider-modal')) return;
      const forms = $$('.jdgm-write-review-modal');
      const visible = forms.find(node => node.isConnected && node.getClientRects().length && getComputedStyle(node).display !== 'none' && getComputedStyle(node).visibility !== 'hidden');
      if (forms.length !== observedReviews.length || forms.some((node, index) => node !== observedReviews[index])) {
        reviewStyleObserver.disconnect(); observedReviews = forms;
        observedReviews.forEach(node => {
          reviewStyleObserver.observe(node, { attributes: true, attributeFilter: ['style', 'class'] });
          const close = $('.jdgm-write-review-modal__close-btn', node);
          if (close) reviewStyleObserver.observe(close, { attributes: true, attributeFilter: ['style', 'aria-hidden', 'tabindex'] });
        });
      }
      if (currentReview && currentReview !== visible) {
        const closed = currentReview, wasActive = activeModal === closed;
        currentReview = null;
        if (wasActive) releaseModal(closed);
        closed.setAttribute('aria-hidden', 'true'); closed.setAttribute('inert', '');
        if (ownsReviewScrollLock && !activeModal && !cartOpen && !mnavOpen) document.body.classList.remove('no-scroll');
        ownsReviewScrollLock = false;
        const opener = reviewOpener; reviewOpener = null;
        if (wasActive && opener?.isConnected && !opener.closest('[inert], [hidden]') && opener.getClientRects().length) {
          opener.scrollIntoView({ behavior: 'instant', block: 'nearest' });
          opener.focus({ preventScroll: true });
        }
        refreshProductAction();
      }
      forms.filter(node => node !== visible).forEach(node => {
        node.setAttribute('aria-hidden', 'true');
        // Do not overwrite a live theme modal's inert snapshot while it owns this sibling.
        if (!modalInert.has(node)) node.setAttribute('inert', '');
      });
      if (!visible) return;
      if (currentReview !== visible) {
        reviewOpener = cartOpen ? cartOpener : mnavOpen ? mnavOpener : document.activeElement;
        if (visible.contains(reviewOpener)) reviewOpener = $('[data-cart-open]');
        currentReview = visible;
      }
      if (cartOpen) closeCart();
      if (mnavOpen) closeMNav();
      if (activeModal && activeModal !== visible && activeModal.classList.contains('glb')) {
        $('.glb__close', activeModal)?.click();
        reviewOpener = document.activeElement;
      }
      visible.removeAttribute('inert'); visible.setAttribute('aria-hidden', 'false');
      if (!document.body.classList.contains('no-scroll')) { ownsReviewScrollLock = true; document.body.classList.add('no-scroll'); }
      const close = $('.jdgm-write-review-modal__close-btn', visible);
      if (close) {
        close.type = 'button'; close.setAttribute('aria-label', uiText('close'));
        if (close.getAttribute('aria-hidden') !== 'false') close.setAttribute('aria-hidden', 'false');
        if (close.tabIndex !== 0) close.tabIndex = 0;
      }
      if (activeModal !== visible) focusModal(visible, close || visible);
    };
    // Discover only added/removed review portals; ordinary cart rows and input text do not schedule a scan.
    const includesReviewPortal = node => node.nodeType === 1 && (node.matches('.jdgm-write-review-modal') || !!node.querySelector('.jdgm-write-review-modal'));
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(includesReviewPortal))) scheduleReviewSync();
    }).observe(document.body, { childList: true, subtree: true });
    coordinateReviewModal();
  }
  /* End M review modal coordination. */

  /* BOGOS modal handoff: observed public DOM only, never gift/cart API calls. */
  {
    const popupSelector = '#freegifts-main-popup-container';
    const canReturnGiftFocus = node => !!node && node !== document.body && node !== document.documentElement &&
      node.isConnected && node.matches('a[href], button, input:not([type="hidden"]), select, textarea, [tabindex]') &&
      !node.matches(':disabled, [aria-disabled="true"]') && !node.closest('[inert], [hidden], [aria-hidden="true"]') &&
      node.getClientRects().length > 0 && getComputedStyle(node).display !== 'none' &&
      !['hidden', 'collapse'].includes(getComputedStyle(node).visibility);
    let observedPopup = null, currentGift = null, giftOpener = null;
    let ownsGiftScrollLock = false, giftTabindex = null, scheduledGiftFrame = 0;
    const scheduleGiftSync = () => {
      if (scheduledGiftFrame) return;
      scheduledGiftFrame = requestAnimationFrame(() => { scheduledGiftFrame = 0; coordinateGiftModal(); });
    };
    const giftStateObserver = new MutationObserver(scheduleGiftSync);
    coordinateGiftModal = () => {
      const popup = $(popupSelector);
      if (popup !== observedPopup) {
        giftStateObserver.disconnect(); observedPopup = popup;
        if (popup) giftStateObserver.observe(popup, { attributes: true, attributeFilter: ['class', 'style', 'hidden'], childList: true, subtree: true });
      }
      const visible = visibleGiftDialog();
      if (currentGift && currentGift !== visible) {
        const closed = currentGift, wasActive = activeModal === closed;
        currentGift = null;
        if (wasActive) releaseModal(closed);
        if (giftTabindex === null) closed.removeAttribute('tabindex'); else closed.setAttribute('tabindex', giftTabindex);
        if (ownsGiftScrollLock && !activeModal && !cartOpen && !mnavOpen) document.body.classList.remove('no-scroll');
        ownsGiftScrollLock = false;
        const opener = giftOpener; giftOpener = null;
        if (wasActive) {
          const returnTarget = canReturnGiftFocus(opener) ? opener : $$('[data-cart-open]').find(canReturnGiftFocus);
          returnTarget?.focus({ preventScroll: true });
        }
        refreshProductAction();
        coordinateReviewModal();
      }
      if (!visible) return;
      if (currentGift !== visible) {
        giftOpener = cartOpen ? cartOpener : mnavOpen ? mnavOpener : document.activeElement;
        if (visible.contains(giftOpener)) giftOpener = $('[data-cart-open]');
        giftTabindex = visible.getAttribute('tabindex');
        currentGift = visible;
      }
      // Release the drawer's inert snapshot before granting focus to the gift portal.
      // No transient focus return to the product and no automatic drawer reopening.
      if (cartOpen) closeCart(false);
      if (mnavOpen) closeMNav(false);
      if (!document.body.classList.contains('no-scroll')) { ownsGiftScrollLock = true; document.body.classList.add('no-scroll'); }
      if (activeModal !== visible) {
        const initial = visible.contains(document.activeElement) ? document.activeElement : $('.bogos-slider-close-btn', visible);
        focusModal(visible, initial || visible, true);
      }
    };
    const includesGiftPopup = node => node.nodeType === 1 && (node.matches(popupSelector) || !!node.querySelector(popupSelector));
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(includesGiftPopup))) scheduleGiftSync();
    }).observe(document.body, { childList: true, subtree: true });
    coordinateGiftModal();
  }
  /* End BOGOS modal handoff. */

  /* ---------- Toast ---------- */
  const toast = $('[data-toast]');
  let toastT;
  const showToast = (msg) => {
    if (!toast) return;
    const tm = $('[data-toast-msg]', toast); if (tm) tm.textContent = msg;
    toast.hidden = false;
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    clearTimeout(toastT);
    toastT = setTimeout(() => { toast.classList.remove('is-visible'); setTimeout(() => toast.hidden = true, 400); }, 2600);
  };

  /* ---------- Cart API ---------- */
  const updateCounts = (count, rendered = false) => {
    // Classification comes only from the server-rendered gift flags, never price/title guesses.
    const lines = rendered ? $$('.cart-line[data-cart-gift]', drawer) : [];
    const total = lines.reduce((sum, line) => sum + Number(line.dataset.quantity || 0), 0);
    const verified = rendered && total === count;
    const gifts = verified ? lines.filter(line => line.dataset.cartGift === 'true').reduce((sum, line) => sum + Number(line.dataset.quantity || 0), 0) : 0;
    const articles = count - gifts;
    $$('[data-cart-count]').forEach(el => {
      el.textContent = verified ? count : '';
      // The header badge counts every item, including gifts; only an empty cart hides it.
      el.hidden = !verified || count === 0;
    });
    const label = verified && count > 0
      ? uiText(gifts > 0 ? 'cart_count_gift_label' : 'cart_count_label', { items: uiCount('items', articles), gifts: uiCount('gifts', gifts) })
      : uiText('cart_label');
    $$('[data-cart-open]').forEach(control => control.setAttribute('aria-label', label));
    const summary = $('[data-cart-summary]', drawer);
    if (summary) {
      summary.textContent = verified && gifts > 0
        ? (articles > 0 ? uiCount('items', articles) + ' + ' : '') + uiCount('gifts', gifts)
        : uiCount('items', count) + (verified ? '' : uiText('cart_total'));
    }
  };
  const quickAddToken = control => JSON.stringify(['add', control.dataset.id, control.dataset.plan || '']);
  const cartFeedback = createCartActionFeedback({
    controls: () => $$('[data-quick-add], [data-remove]'),
    tokenFor: control => control.hasAttribute('data-remove') ? 'remove:' + control.dataset.key : quickAddToken(control),
    status: () => drawer?.querySelector('[data-cart-progress]')
  });
  // Recommendations may replace their own buttons independently of a full cart refresh.
  if (drawer) new MutationObserver(() => cartFeedback.render()).observe(drawer, { childList: true, subtree: true });
  const swapDrawer = (sectionsHTML) => {
    if (!sectionsHTML || !sectionsHTML['cart-drawer']) return false;
    const tmp = document.createElement('div');
    tmp.innerHTML = sectionsHTML['cart-drawer'];
    const fresh = tmp.querySelector('[data-cart-drawer]');
    if (fresh && drawer) {
      cartFocus?.beforeChange();
      drawer.innerHTML = fresh.innerHTML;
      restoreRituelOffers();
      updateCartShipping();
      cartFeedback.render();
      cartFocus?.restore();
      return true;
    }
    return false;
  };

  const cartMessage = message => {
    if (!drawer) { showToast(message); return; }
    let box = $('[data-cart-error]', drawer);
    if (!box) {
      box = document.createElement('p'); box.dataset.cartError = ''; box.setAttribute('role', 'status');
      box.style.cssText = 'padding:1rem;border:1px solid currentColor;margin:1rem;';
      drawer.insertBefore(box, $('[data-cart-foot]', drawer));
    }
    box.textContent = message + ' ';
    const link = document.createElement('a'); link.href = route('cart'); link.dataset.cartPageLink = ''; link.textContent = uiText('view_cart'); link.style.textDecoration = 'underline';
    link.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault(); event.stopPropagation(); window.location.assign(link.href);
    });
    box.appendChild(link);
  };
  const requestCart = async (path, body) => {
    // Only abort reads. A timed-out POST may already be accepted and must never be blindly replayed.
    const abort = body ? null : new AbortController();
    const timer = abort ? setTimeout(() => abort.abort(), 8000) : null;
    try {
      const res = await fetch(route(path), {
        method: body ? 'POST' : 'GET',
        cache: 'no-store',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        ...(abort ? { signal: abort.signal } : {}),
        ...(body ? { body: JSON.stringify({ ...body, sections_url: window.location.pathname }) } : {})
      });
      const data = await res.json().catch(() => null);
      if (!res.ok || !data) {
        const error = new Error(data?.description || data?.message || uiText('cart_verify_reload'));
        // Preserve a parsed Shopify status; even a 422 can have added the available stock.
        if (body && data) error.cartResponseStatus = res.status;
        throw error;
      }
      return data;
    } catch (error) {
      if (abort?.signal.aborted) throw new Error(uiText('cart_verify_timeout'));
      throw error;
    } finally { if (timer !== null) clearTimeout(timer); }
  };
  let checkoutRunning = false;
  const updateCheckoutState = () => {
    $$('[data-checkout]').forEach(control => {
      if (checkoutRunning) {
        if (!control.hasAttribute('data-checkout-label')) control.dataset.checkoutLabel = control.textContent;
        control.textContent = uiText('checkout_preparing');
        control.setAttribute('aria-busy', 'true'); control.setAttribute('aria-disabled', 'true');
      } else if (control.hasAttribute('data-checkout-label')) {
        control.textContent = control.dataset.checkoutLabel; delete control.dataset.checkoutLabel;
        control.removeAttribute('aria-disabled'); control.setAttribute('aria-busy', 'false');
      }
    });
  };
  const cartController = createCartController({
    request: async (...args) => {
      const data = await requestCart(...args);
      try { if (args[0] === 'cart.js' || args[0] === 'cart/change.js') cartFocus?.remember(data); } catch (_) { /* Presentation metadata must never fail a cart request. */ }
      return data;
    },
    replaceVariant: args => window.GSBladeVariants.replace(args),
    readSections: () => fetchCartSections(window.fetch.bind(window), window.location.href),
    beforeCheckout: async () => {
      const gifts = window.BOGOS_CORE?.helper?.gift;
      if (typeof gifts?.prepareCheckout === 'function') await gifts.prepareCheckout();
    },
    onState: (cart, sections) => {
      const rendered = swapDrawer(sections);
      if (cart) updateCounts(cart.item_count, rendered);
      else if (rendered) updateCounts($$('.cart-line[data-quantity]', drawer).reduce((sum, line) => sum + Number(line.dataset.quantity || 0), 0), true);
      if (!rendered) cartMessage(uiText('cart_updated_check'));
      return rendered;
    },
    onBusy: ({ pending, locked }) => {
      cartFocus?.setLocked(locked);
      // Keep the live progress message outside the busy items region so it can be announced immediately.
      if (drawer) { drawer.removeAttribute('aria-busy'); $('[data-cart-items]', drawer)?.setAttribute('aria-busy', String(pending)); }
      $$('[data-qty-up], [data-qty-down], [data-qty-input], [data-sub-on], [data-sub-off], [data-remove], [data-cart-blade-select]', drawer || document).forEach(control => {
        if (locked && (!control.disabled || control.hasAttribute('data-cart-feedback'))) { control.disabled = true; control.dataset.cartLocked = ''; }
        else if (!locked && control.hasAttribute('data-cart-locked')) { control.disabled = false; delete control.dataset.cartLocked; }
      });
      $$('[data-checkout]').forEach(control => control.setAttribute('aria-busy', String(pending)));
      updateCheckoutState();
      cartFeedback.setBusy(pending);
      if (!locked) cartFocus?.restore();
    },
    onError: error => { cartMessage(error.message); showToast(error.message); }
  });
  // History can restore an old drawer and controller state after checkout.
  // Reuse the serialized, gift-aware read path; normal loads/adds do not pay for this refresh.
  window.addEventListener('pageshow', event => {
    const historyReturn = window.performance?.getEntriesByType?.('navigation')?.[0]?.type === 'back_forward';
    if (event.persisted || historyReturn) cartController.refresh().catch(() => {});
  });
  // Official BOGOS SDK events: gift updates are independent of our original add.js response.
  document.addEventListener('gs:cart-blade-change', e => {
    if (!e.detail || !window.GSBladeVariants || !drawer?.contains(e.target) || !cartActionAllowed(e.target)) return;
    e.detail.task = cartController.changeVariant(e.detail.key, e.detail.variantId, e.detail.variants);
  });
  window.GSBladeVariantsReady = true;
  document.dispatchEvent(new CustomEvent('gs:cart-blade-ready'));
  ['fg-cart:auto-updated', 'fg-gifts:updated', 'fg-gifts:added'].forEach(event => {
    document.addEventListener(event, () => { cartController.refresh().catch(() => {}); });
  });
  const addToCart = async (id, quantity = 1, sellingPlan = null, properties = null) => {
    const result = await cartController.add(id, quantity, sellingPlan, properties);
    const li = (result.data.items && result.data.items[0]) || result.data;
    const acceptedQuantity = result.quantityAdded ?? quantity;
    const price = (li.final_price ?? li.price ?? 0) / 100;
    track('add_to_cart', {
      currency: result.cart?.currency || window.Shopify?.currency?.active || 'EUR', value: price * acceptedQuantity,
      items: [{ item_id: String(li.product_id || id), item_name: li.product_title || li.title, item_variant: li.variant_title, price, quantity: acceptedQuantity }]
    });
    if (result.notice) cartMessage(result.notice);
    return result;
  };
  const proceedToCheckout = async url => {
    if (checkoutRunning) return;
    checkoutRunning = true;
    updateCheckoutState();
    try {
      const cart = await cartController.checkout();
      track('begin_checkout', {
        currency: cart.currency, value: cart.total_price / 100,
        items: cart.items.map(item => ({ item_id: String(item.product_id), item_name: item.product_title || item.title, item_variant: item.variant_title, price: item.final_price / 100, quantity: item.quantity }))
      });
      window.location.assign(url || route('checkout'));
    } catch (error) { cartMessage(error.message); showToast(error.message); }
    finally { checkoutRunning = false; updateCheckoutState(); }
  };

  /* Drawer line interactions (delegated) */
  drawer?.addEventListener('click', async (e) => {
    const collapse = e.target.closest('[data-offer-collapse]');
    if (collapse) {
      const offer = collapse.closest('[data-offer-variant]');
      collapseRituelOffer(offer.dataset.offerVariant);
      offer.querySelector('.cart-rituel-offer__cta')?.focus({preventScroll:true});
      return;
    }
    const editorTrigger = e.target.closest('[data-rituel-edit]');
    if (editorTrigger) {
      e.preventDefault();
      const template = editorTrigger.parentElement.querySelector('[data-rituel-editor]');
      if (!template || document.querySelector('.rituel-editor[open]')) return;
      const dialog = template.content.firstElementChild.cloneNode(true);
      document.body.append(dialog);
      const initial = dialog.querySelector('input:checked')?.value || '';
      const scope = dialog.querySelector('[data-rituel-scope]');
      const updateScope = () => {
        const chosen = dialog.querySelector('input[name="rituel-choice"]:checked')?.value || '';
        if (scope) { scope.hidden = false; if (chosen !== initial) dialog.querySelector('[data-rituel-apply]').textContent = uiLanguage() === 'en' ? 'Confirm' : 'Valider'; }
        const split = scope && chosen !== initial && scope.querySelector('input:checked')?.value === 'one';
        dialog.querySelectorAll('[data-single-change]').forEach(panel => { panel.hidden = !split; });
        dialog.querySelectorAll('[data-all-change]').forEach(panel => { panel.hidden = !!split; });
      };
      const updateChoiceLabel = plan => {
        const english = uiLanguage() === 'en';
        dialog.querySelector('[data-rituel-apply]').textContent = plan === initial
          ? (english ? 'Keep my plan' : 'Garder ma formule')
          : plan === ''
            ? (english ? 'Switch to a one-time purchase' : 'Passer à l’achat unique')
            : (english ? 'Choose this schedule' : 'Choisir ce rythme');
      };
      updateChoiceLabel(initial);
      updateScope();
      const orderDate = new Date();
      dialog.querySelectorAll('[data-next-refill]').forEach(note => {
        const months = Number(note.dataset.nextRefill);
        if (!Number.isInteger(months) || months < 1) return;
        const next = new Date(orderDate.getFullYear(), orderDate.getMonth() + months, 1, 12);
        const lastDay = new Date(next.getFullYear(), next.getMonth() + 1, 0).getDate();
        next.setDate(Math.min(orderDate.getDate(), lastDay));
        const time = note.querySelector('time');
        time.dateTime = `${next.getFullYear()}-${String(next.getMonth() + 1).padStart(2, '0')}-${String(next.getDate()).padStart(2, '0')}`;
        time.textContent = new Intl.DateTimeFormat(uiLanguage() === 'en' ? 'en-GB' : 'fr-FR', {day:'numeric', month:'long', year:'numeric'}).format(next);
        note.hidden = false;
      });
      let applying = false;
      dialog.addEventListener('keydown', event => event.stopPropagation());
      dialog.addEventListener('cancel', event => { if (applying) event.preventDefault(); });
      dialog.addEventListener('close', () => {
        dialog.remove();
        (editorTrigger.isConnected ? editorTrigger : drawer.querySelector('[data-cart-close]'))?.focus({preventScroll:true});
      });
      dialog.querySelector('[data-rituel-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('change', event => {
        if (event.target.matches('input[name="rituel-scope"]')) { updateScope(); return; }
        if (!event.target.matches('input[name="rituel-choice"]')) return;
        dialog.querySelectorAll('[data-rituel-recap]').forEach(panel => { panel.hidden = panel.dataset.rituelRecap !== event.target.value; });
        dialog.querySelector('[data-rituel-reassurance]').hidden = event.target.value === '';
        updateChoiceLabel(event.target.value);
        updateScope();
      });
      if (editorTrigger.dataset.offerPlan) {
        const suggested = Array.from(dialog.querySelectorAll('input[name="rituel-choice"]')).find(input => input.value === editorTrigger.dataset.offerPlan);
        if (suggested) { suggested.checked = true; suggested.dispatchEvent(new Event('change', {bubbles:true})); }
      }
      dialog.querySelector('[data-rituel-apply]').addEventListener('click', async () => {
        if (applying) return;
        const plan = dialog.querySelector('input[name="rituel-choice"]:checked')?.value || '';
        if (plan === initial) { if (plan === '') collapseRituelOffer(dialog.dataset.variantId); dialog.close(); return; }
        applying = true;
        dialog.querySelectorAll('button,input').forEach(control => { control.disabled = true; });
        try {
          await cartController.changePlan(dialog.dataset.key, plan, {
            variant_id: dialog.dataset.variantId,
            quantity: Number(dialog.dataset.lineQuantity),
            properties: JSON.parse(dialog.dataset.lineProperties || '{}'),
            selling_plan_allocation: { selling_plan: { id: dialog.dataset.currentPlan } }
          }, !!scope && !scope.hidden && scope.querySelector('input:checked')?.value === 'one');
          if (plan === '') collapseRituelOffer(dialog.dataset.variantId);
          dialog.close();
          showToast(plan ? rituelActivationMessage(dialog.querySelector('input[name="rituel-choice"]:checked')) : (uiLanguage() === 'en' ? 'Your choice has been updated' : 'Votre choix a été mis à jour'));
        } catch (error) {
          const message = dialog.querySelector('[role="alert"]');
          message.textContent = error.message; message.hidden = false;
        } finally {
          applying = false;
          dialog.querySelectorAll('button,input').forEach(control => { control.disabled = false; });
        }
      });
      dialog.showModal();
      return;
    }
    function rituelActivationMessage(control) {
      const en = uiLanguage() === 'en';
      const percent = Number(control?.dataset.rituelDiscount);
      const product = control?.dataset.rituelProduct;
      const lead = en ? 'Ritual activated' : 'Rituel activé';
      if (!Number.isFinite(percent) || percent <= 0 || percent >= 100 || !['shaver', 'refills'].includes(product)) return lead;
      const scope = product === 'shaver' ? (en ? 'on your shaver' : 'sur votre rasoir') : (en ? 'on your refills' : 'sur vos recharges');
      return `${lead} · −${percent} % ${scope}`;
    }
    const subOn = e.target.closest('[data-sub-on]');
    if (subOn) { e.preventDefault(); try { await cartController.changePlan(subOn.dataset.key, subOn.dataset.plan); showToast(rituelActivationMessage(subOn));  } catch (_) {} return; }
    const subOff = e.target.closest('[data-sub-off]');
    if (subOff) { e.preventDefault(); try { await cartController.changePlan(subOff.dataset.key, ''); showToast(uiLanguage() === 'en' ? 'One-time purchase selected' : 'Achat unique sélectionné'); } catch (_) {} return; }
    const line = e.target.closest('[data-key]');
    const remove = e.target.closest('[data-remove]');
    if (remove) {
      e.preventDefault(); if (remove.disabled) return;
      const finish = cartFeedback.begin('remove:' + remove.dataset.key, uiText('removing'));
      if (!finish) return;
      try { await cartController.remove(remove.dataset.key); } catch (_) {} finally { finish(); }
      return;
    }
    if (!line) return;
    const key = line.dataset.key;
    const input = $('[data-qty-input]', line);
    if (!input) return;
    const v = parseInt(input.value) || 0;
    if (e.target.closest('[data-qty-up]')) { const n = v + 1; input.value = n; cartController.scheduleQuantity(key, n); }
    if (e.target.closest('[data-qty-down]')) { const n = Math.max(0, v - 1); input.value = n; cartController.scheduleQuantity(key, n); }
  });
  drawer?.addEventListener('change', async (e) => {
    if (e.target.matches('[data-qty-input]')) { try { await cartController.changeQuantity(e.target.dataset.key, Math.max(0, parseInt(e.target.value) || 0)); } catch (_) {} }
  });

  /* ---------- Quick-add (cart cross-sell) ---------- */
  document.addEventListener('click', async (e) => {
    const button = e.target.closest('[data-blade-apply]');
    if (!button) return;
    e.preventDefault();
    if (button.disabled || !cartActionAllowed(button)) return;
    const card = button.closest('[data-blade-candidate]');
    const host = card?.closest('gs-cart-recommendations');
    if (!host?.bladeTiersReady()) return;
    const revision = cartDismissRevision, label = button.textContent;
    button.disabled = true;button.textContent = uiText('adding');
    const controls = [...card.querySelectorAll('[data-blade-options] button')];
    const previous = controls.map(b => b.disabled);controls.forEach(b => b.disabled = true);
    try {
      const data = JSON.parse(card.querySelector('[data-blade-data]').textContent);
      const target = Number(card.dataset.bladeTarget);
      if (!Number.isInteger(target) || target < 1 || target > 4 || target > data.available) throw new Error(uiText('line_changed'));
      const result = data.source ? await cartController.setBladeQuantity(data.source,target) :
        await addToCart(data.variant,target,null,{_gs_upsell_source:card.dataset.recSource,_gs_upsell_version:'blade-d347',_gs_upsell_seed:card.dataset.recSeed || ''});
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true) track('gs_cart_blade_quantity_added',{variant_id:data.variant,target_quantity:target,previous_quantity:data.source?.quantity || 0,version:'blade-d347'});
      openCartAfterAdd(revision);showToast(result.notice || uiText('added'));
    } catch (error) { showToast(error.message || uiText('cart_change_failed')); }
    finally { if(button.isConnected){button.disabled=false;button.textContent=label;controls.forEach((b,i)=>b.disabled=previous[i]);} }
  });
  document.addEventListener('click', async (e) => {
    const button = e.target.closest('[data-cart-duo]');
    if (!button) return;
    e.preventDefault();
    if (button.disabled || !cartActionAllowed(button)) return;
    const revision = cartDismissRevision, label = button.textContent;
    button.disabled = true; button.textContent = uiText('adding');
    try {
      const items = JSON.parse(button.dataset.duoItems);
      const result = await cartController.addMany(items);
      if (!result.partial && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true) {
        track('gs_cart_duo_added',{variant_ids:items.map(item => item.id),version:'duo-d343'});
      }
      openCartAfterAdd(revision); showToast(result.notice || uiText('added'));
    } catch (error) { showToast(error.message || uiText('cart_change_failed')); }
    finally { if (button.isConnected) { button.disabled = false; button.textContent = label; } }
  });
  document.addEventListener('click', async (e) => {
    const qa = e.target.closest('[data-quick-add]');
    if (!qa) return;
    e.preventDefault();
    if (qa.disabled || !cartActionAllowed(qa)) return;
    const cartOpeningRevision = cartDismissRevision;
    const finish = cartFeedback.begin(quickAddToken(qa), uiText('adding'));
    if (!finish) return;
    try {
      const rec = qa.closest('[data-rec-product]');
      const properties = rec ? { _gs_upsell_source: rec.dataset.recSource, _gs_upsell_version: 'shopify-d334', _gs_upsell_seed: rec.dataset.recSeed || '' } : null;
      const result = await addToCart(qa.dataset.id, 1, qa.dataset.plan || null, properties);
      if (rec && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true) track('gs_cart_recommendation_added', { source: rec.dataset.recSource, product_id: rec.dataset.recProduct, variant_id: qa.dataset.id, version: 'shopify-d334' });
      openCartAfterAdd(cartOpeningRevision);
      showToast(result.notice || uiText('added'));
    } catch (err) {
      showToast(err.message || (uiLanguage() === 'en' ? 'Cart error' : 'Erreur panier'));
    } finally {
      finish();
    }
  });

  /* ---------- Generic quantity steppers (product form) ---------- */
  document.addEventListener('click', (e) => {
    const wrap = e.target.closest('.qty');
    if (!wrap || wrap.closest('[data-cart-drawer]')) return;
    const input = $('[data-qty-input]', wrap);
    if (!input) return;
    const minimum = input.min === '0' ? 0 : 1;
    const current = Number.isFinite(parseInt(input.value, 10)) ? parseInt(input.value, 10) : minimum;
    if (e.target.closest('[data-qty-up]')) input.value = Math.max(minimum, current) + 1;
    else if (e.target.closest('[data-qty-down]')) input.value = Math.max(minimum, current - 1);
    else return;
    // Notify dependants after the value changes; a root click microtask can run before this document handler.
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ============================================================
     PRODUCT PAGE
     ============================================================ */
  const root = $('[data-product-root]');
  if (root) {
    const form = $('[data-product-form]', root);
    const variantInput = $('[data-variant-id]', root);
    const priceEl = $('[data-price]', root);
    // O: mirror the submitted variant beside the price; never alter purchase state.
    const selectedKitLabel = $('[data-selected-kit]', root);
    function updateSelectedKitLabel() {
      if (!selectedKitLabel || !variantInput) return;
      const id = String(variantInput.value);
      const card = $$('[data-variant-card]', root).find(node => String(node.dataset.variantId) === id);
      let title = card?.dataset.variantTitle || '';
      if (!title) {
        try { title = JSON.parse($('[data-variants-json]', root)?.textContent || '[]').find(variant => String(variant.id) === id)?.title || ''; }
        catch (_) { /* An unreadable optional catalog cannot replace the authoritative initial title. */ }
      }
      if (!title && id === selectedKitLabel.dataset.initialVariantId) title = selectedKitLabel.dataset.initialVariantTitle || '';
      const visible = !!title && title !== 'Default Title';
      selectedKitLabel.hidden = !visible;
      const label = visible ? selectedKitLabel.dataset.labelTemplate.replace('__MODEL__', title) : '';
      if (selectedKitLabel.textContent !== label) selectedKitLabel.textContent = label;
    }
    window.addEventListener('pageshow', updateSelectedKitLabel);
    window.addEventListener('popstate', () => queueMicrotask(updateSelectedKitLabel));
    // End O selected-kit label.

    const stickyPrice = $('[data-sticky-price]');
    const atcBtn = $('[data-atc]', root);
    const atcText = $('[data-atc-text]', root);
    const atcRow = $('.atc-row', root);
    const payWrap = $('.shopify-payment-button', root);
    const restock = $('[data-restock]', root);
    const restockApp = $('[data-restock-app]', root);
    const stockLine = $('[data-stock]', root);
    const deliveryPromise = $('[data-delivery-promise]', root);
    const stickyBtn = $('[data-sticky-atc-btn]');
    const stickyBar = $('[data-sticky-atc]');
    let stickyCanAdd = false;
    let isAvailable = root.dataset.initialAvailable !== 'false', productAdding = false;

    /* Shared gallery: rendering, variant filtering, touch and zoom. */
    const productGallery = window.GSProductGallery?.init($('[data-gallery]', root));

    const setPrice = (priceCents, compareCents) => {
      if (priceEl) priceEl.textContent = money(priceCents);
      if (stickyPrice) stickyPrice.textContent = money(priceCents);
      const cmp = $('[data-compare]', root);
      const save = $('[data-save]', root);
      if (compareCents && compareCents > priceCents) {
        if (cmp) { cmp.textContent = money(compareCents); cmp.style.display = ''; }
        if (save) { save.textContent = '-' + Math.round((compareCents - priceCents) / compareCents * 100) + '%'; save.style.display = ''; }
      } else {
        if (cmp) cmp.style.display = 'none';
        if (save) save.style.display = 'none';
      }
      const perUnit = $('[data-per-unit]', root);
      if (perUnit) {
        const shaves = parseInt(perUnit.dataset.shaves) || 0;
        if (shaves > 0 && priceCents > 0) { perUnit.textContent = uiText('per_shave', { amount: money(Math.round(priceCents / shaves)) }); perUnit.hidden = false; }
        else { perUnit.hidden = true; }
      }
    };
    const setAvailability = (available) => {
      isAvailable = available;
      if (atcBtn) atcBtn.disabled = !available || productAdding || ((requiresPlan() || !!pendingBladePlan) && !selectedPlan);
      // Text owns both the availability state AND the one-time vs subscription label
      if (atcText) atcText.textContent = !available
        ? uiText('unavailable')
        : uiText('add');
      // Swap the buy controls for the back-in-stock capture when sold out.
      // Use style.display (not [hidden]) : .atc-row has an explicit display:flex that would beat [hidden].
      if (atcRow) atcRow.style.display = available ? '' : 'none';
      if (payWrap) payWrap.style.display = available ? '' : 'none';
      // Hide the one-time/subscription selector too : no point configuring a plan you can't buy yet
      const po = $('[data-purchase-options]', root);
      if (po) {
        po.style.display = available ? '' : 'none';
        const poHead = po.previousElementSibling;
        if (poHead && poHead.classList.contains('step-head')) poHead.style.display = available ? '' : 'none';
      }
      updateStickyPurchase(); updateVisibleRitualOffer();
      if (stockLine) stockLine.innerHTML = available
        ? '<span><span class="stock-dot"></span>' + uiText('in_stock') + '</span>'
        : '<span><span class="stock-dot stock-dot--low"></span>' + uiText('out_of_stock') + '</span>';
      if (deliveryPromise) deliveryPromise.hidden = !available;
      $$('[data-dispatch-promise]', root).forEach(promise => { promise.hidden = !available; });
      if (restockApp) restockApp.hidden = available;
      updateStockAlternative();
      if (restock) {
        restock.hidden = available;
        if (!available) {
          const active = $('[data-variant-card].is-active', root);
          const vlabel = $('[data-restock-variant]', restock);
          if (vlabel) vlabel.textContent = active && active.dataset.variantTitle ? active.dataset.variantTitle : '';
          const f = $('[data-restock-form]', restock); if (f) f.hidden = false;
          const ok = $('[data-restock-ok]', restock); if (ok) ok.hidden = true;
          const err = $('[data-restock-err]', restock); if (err) err.hidden = true;
          const etaEl = $('[data-restock-eta]', restock);
          if (etaEl) {
            const etaVal = active && active.dataset.variantEta ? active.dataset.variantEta.trim() : '';
            const etaValEl = $('[data-restock-eta-val]', etaEl);
            if (etaVal && etaValEl) { etaValEl.textContent = etaVal; etaEl.hidden = false; } else { etaEl.hidden = true; }
          }
        }
      }
    };

    /* ---------- Subscription (Recharge selling plans) ---------- */
    const subDataEl = $('[data-sub-data]', root);
    let subData = null;
    if (subDataEl) { try { subData = JSON.parse(subDataEl.textContent); } catch (e) {} }
    const sellingPlanInput = $('[data-selling-plan]', root);
    const poCards = $$('[data-po-card]', root);
    const freqSelect = $('[data-po-freq]', root);
    const freqWrap = $('[data-po-freq-wrap]', root);
    const cadenceChoices = $('[data-po-cadences]', root);
    let purchaseType = 'onetime';
    let selectedPlan = null;
    let pendingBladePlan = null;
    let purchaseReady = false;
    let curOneTime = 0, curCompare = 0;

    const plansFor = (vid) => (subData && subData[vid] && subData[vid].plans) || [];
    const requiresPlan = () => subData?.[variantInput.value]?.requiresSellingPlan ?? (root.dataset.requiresSellingPlan === 'true');
    const pct = (one, sub) => one ? Math.max(0, Math.round((one - sub) / one * 100)) : 0;

    function updateStockAlternative() {
      const alternative = $('[data-stock-alternative]', root);
      if (!alternative) return;
      alternative.hidden = isAvailable || variantInput.value !== alternative.dataset.fromVariant;
      const target = $$('[data-variant-card]', root).find(card => card.dataset.variantId === alternative.dataset.toVariant);
      const button = $('[data-stock-alternative-action]', alternative);
      const note = $('[data-stock-alternative-note]', alternative);
      const available = target?.dataset.variantAvailable === 'true';
      // This shortcut must never silently change a subscription into a one-time purchase.
      const compatible = purchaseType === 'subscribe'
        ? !!selectedPlan && !!compatiblePlan(plansFor(alternative.dataset.toVariant), selectedPlan)
        : !(subData?.[alternative.dataset.toVariant]?.requiresSellingPlan ?? (root.dataset.requiresSellingPlan === 'true'));
      if (button) button.disabled = !purchaseReady || productAdding || !available || !compatible;
      if (note) note.textContent = !available
        ? uiText('plus_unavailable')
        : !compatible
          ? uiText('plus_plan_unavailable')
          : uiText(purchaseType === 'subscribe' ? 'elite_alternative_ritual' : 'elite_alternative_unique');
    }
    $('[data-stock-alternative-action]', root)?.addEventListener('click', () => {
      updateStockAlternative();
      const alternative = $('[data-stock-alternative]', root);
      const button = $('[data-stock-alternative-action]', alternative);
      if (alternative.hidden || button.disabled) return;
      const target = $$('[data-variant-card]', root).find(card => card.dataset.variantId === alternative.dataset.toVariant);
      const radio = $('input[type=radio]', target);
      if (!radio || radio.disabled) return;
      radio.click();
      radio.focus({ preventScroll: true });
    });

    const rebuildFreq = () => {
      if (!freqSelect) return;
      const plans = plansFor(variantInput.value);
      const previous = selectedPlan || pendingBladePlan;
      freqSelect.innerHTML = '';
      plans.forEach(pl => {
        const o = document.createElement('option');
        o.value = pl.id;
        o.textContent = cadenceDisplay(pl);
        freqSelect.appendChild(o);
      });
      selectedPlan = compatiblePlan(plans, previous) || plans[0] || null;
      if (root.hasAttribute('data-blade-purchase') && purchaseType === 'subscribe' && previous && !compatiblePlan(plans, previous)) {
        pendingBladePlan = previous;
        selectedPlan = null;
        const placeholder = document.createElement('option'); placeholder.value = ''; placeholder.textContent = uiText('choose_frequency');
        freqSelect.prepend(placeholder); freqSelect.value = '';
      } else if (requiresPlan() && previous && !compatiblePlan(plans, previous)) {
        selectedPlan = null;
        const placeholder = document.createElement('option'); placeholder.value = ''; placeholder.textContent = uiText('choose_frequency');
        freqSelect.prepend(placeholder); freqSelect.value = '';
        purchaseType = 'subscribe';
        showToast(uiText('choose_available_frequency'));
      } else if (requiresPlan()) {
        purchaseType = 'subscribe';
      } else if (purchaseType === 'subscribe' && (!selectedPlan || (previous && !compatiblePlan(plans, previous)))) {
        purchaseType = 'onetime';
        showToast(uiText('plan_mismatch'));
      }
      if (selectedPlan) { pendingBladePlan = null; freqSelect.value = selectedPlan.id; }
      if (cadenceChoices) {
        cadenceChoices.replaceChildren();
        plans.forEach(plan => {
          const label = document.createElement('label'); label.className = 'po-cadence';
          const radio = document.createElement('input'); radio.type = 'radio'; radio.name = '__cadence'; radio.value = String(plan.id);
          const body = document.createElement('span');
          const title = document.createElement('strong');
          const compactCadence = root.classList.contains('pdp-razor') ? verifiedCadence(plan) : '';
          title.textContent = compactCadence === 'month:2:2' ? uiText('pdp_cadence_months', { count: 2 }) : compactCadence === 'month:3:3' ? uiText('pdp_cadence_months', { count: 3 }) : cadenceDisplay(plan);
          body.append(title);
          if (!root.classList.contains('pdp-razor') && Number.isFinite(plan.renewalPrice)) {
            const price = document.createElement('small'); price.textContent = uiText('per_refill', { amount: money(plan.renewalPrice) }); body.append(price);
          }
          label.append(radio, body); cadenceChoices.append(label);
        });
        cadenceChoices.hidden = !plans.length;
        freqSelect.hidden = !!plans.length;
      }
    };
    // Razor kits use an explicitly labelled one-time comparison basis; other products retain their selected-plan prices.
    const updateSegPrices = () => {
      $$('[data-variant-card]', root).forEach(seg => {
        const el = $('[data-seg-price]', seg); if (!el) return;
        const vid = seg.dataset.variantId;
        let cents = parseInt(seg.dataset.variantPrice);
        const plans = subData && subData[vid] && subData[vid].plans;
        if (!root.classList.contains('pdp-razor') && purchaseType === 'subscribe' && plans && plans.length) {
          const p = compatiblePlan(plans, selectedPlan);
          if (p) cents = p.price;
          else { el.textContent = uiText('one_time_price', { amount: money(cents) }); return; }
        }
        el.textContent = money(cents);
      });
    };
    // M: the alternative is informational; it never writes purchase state or changes the submitted plan.
    function updateVisibleRitualOffer() {
      const offer = $('[data-visible-ritual-offer]', root);
      if (!offer) return;
      const plan = selectedPlan && plansFor(variantInput.value).find(candidate => String(candidate.id) === String(selectedPlan.id));
      const renewal = plan ? renewalCopy(plan, money) : '';
      const visible = purchaseReady && isAvailable && purchaseType === 'onetime' && !requiresPlan() && !!plan && Number.isFinite(plan.price) && plan.price >= 0 && !!cadenceDisplay(plan) && !!renewal;
      offer.hidden = !visible;
      if (!visible) return;
      $('[data-offer-price]', offer).textContent = money(plan.price);
      $('[data-offer-renewal]', offer).textContent = renewal;
      $('[data-offer-unit]', offer).hidden = Math.max(1, parseInt($('[data-qty-input]', root)?.value || '1', 10) || 1) === 1;
      offer.dataset.planId = String(plan.id);
    }
    $('[data-offer-view]', root)?.addEventListener('click', event => {
      const target = document.getElementById($('[data-purchase-options]', root)?.getAttribute('aria-labelledby'));
      if (!target) return;
      event.preventDefault();
      target.setAttribute('tabindex', '-1');
      target.scrollIntoView({ behavior: 'instant', block: 'center' });
      target.focus({ preventScroll: true });
    });
    // Render after normalization, from the same plan and price used by the product form.
    function updateProductCta() {
      if (root.hasAttribute('data-groombox-product')) {
        root.dispatchEvent(new CustomEvent('groombox:state', { detail: { adding: productAdding, available: isAvailable } }));
        return;
      }
      const showTotal = root.dataset.ctaTotal === 'true';
      if (!showTotal && !root.classList.contains('pdp-razor') && !root.hasAttribute('data-blade-purchase')) return;
      const subscribed = purchaseType === 'subscribe';
      const validPlan = selectedPlan && plansFor(variantInput.value).some(plan => String(plan.id) === String(selectedPlan.id)) && !sellingPlanInput?.disabled && String(sellingPlanInput?.value) === String(selectedPlan.id);
      const card = $('[data-variant-card].is-active', root);
      const cardPrice = String(card?.dataset.variantId) === String(variantInput.value) ? card.dataset.variantPrice : undefined;
      const rawPrice = subscribed ? selectedPlan?.price : (cardPrice ?? subData?.[variantInput.value]?.oneTime ?? variants?.find(variant => String(variant.id) === String(variantInput.value))?.price ?? (String(root.dataset.initialVariantId) === String(variantInput.value) ? root.dataset.initialUnitPrice : undefined));
      const quantity = Math.max(1, parseInt($('[data-qty-input]', root)?.value || 1, 10) || 1);
      const amount = Number(rawPrice), total = amount * quantity;
      const valid = purchaseReady && !pendingBladePlan && (!(subscribed || requiresPlan()) || validPlan) && rawPrice !== undefined && rawPrice !== null && rawPrice !== '' && Number.isSafeInteger(amount) && amount >= 0 && Number.isSafeInteger(total);
      const action = subscribed ? (uiLanguage() === 'en' ? 'Start the Ritual' : 'Démarrer le Rituel') : uiText('add');
      const label = !isAvailable ? uiText('unavailable') : productAdding ? uiText('adding') : valid ? action + (showTotal ? ' — ' + money(total) : '') : uiText('add');
      if (atcText) atcText.textContent = label;
      if (stickyBtn && (stickyCanAdd || !isAvailable || productAdding)) stickyBtn.textContent = label;
    }
    function updateStickyPurchase() {
      updateProductCta();
      if (!stickyBar || !stickyBtn) return;
      const subscribed = purchaseType === 'subscribe';
      let recurring = subscribed ? renewalCopy(selectedPlan, money) : '';
      if (root.classList.contains('pdp-razor')) recurring = recurring.replace(uiLanguage() === 'en' ? 'per item' : 'par article', uiLanguage() === 'en' ? 'per refill' : 'par recharge');
      const cadence = subscribed && selectedPlan ? cadenceDisplay(selectedPlan) : '';
      const planMatches = !subscribed || (!!selectedPlan && !sellingPlanInput?.disabled && String(sellingPlanInput?.value) === String(selectedPlan.id));
      const amount = subscribed ? selectedPlan?.price : curOneTime;
      stickyCanAdd = purchaseReady && Number.isFinite(amount) && amount >= 0 && planMatches && (!subscribed || (!!recurring && !!cadence));
      const activeCard = $('[data-variant-card].is-active', root);
      const chosenVariant = activeCard?.dataset.variantTitle || (typeof variants !== 'undefined' && variants?.find(v => String(v.id) === String(variantInput.value))?.title);
      const label = chosenVariant && chosenVariant !== 'Default Title' ? chosenVariant : stickyBar.dataset.productTitle;
      const qty = Math.max(1, parseInt($('[data-qty-input]', root)?.value || '1', 10) || 1);
      const ritualLabel = root.classList.contains('pdp-razor') ? (uiLanguage() === 'en' ? 'The Ritual' : 'Le Rituel') : stickyBar.dataset.ritualLabel;
      $('[data-sticky-selection]', stickyBar).textContent = [qty > 1 ? qty + ' × ' + label : label, subscribed ? ritualLabel : uiText('one_time')].filter(Boolean).join(' · ');
      if (root.classList.contains('pdp-razor')) {
        $$('[data-pdp-closing-selection]').forEach(summary => {
          summary.textContent = $('[data-sticky-selection]', stickyBar).textContent;
          summary.hidden = false;
        });
      }
      $('[data-sticky-recurring]', stickyBar).hidden = !subscribed || root.classList.contains('pdp-razor');
      $('[data-sticky-renewal]', stickyBar).textContent = subscribed ? recurring || uiText('renewal_unknown') : '';
      stickyBtn.disabled = !isAvailable || productAdding || !purchaseReady;
      stickyBtn.textContent = !isAvailable ? uiText('unavailable') : productAdding ? uiText('adding') : stickyCanAdd ? uiText('add') : stickyBar.dataset.reviewLabel;
      stickyBar.dataset.action = stickyCanAdd ? 'add' : 'review';
      updateProductCta();
    }
    // Keep the selected kit's one-time offer aligned with its visible price.
    // A subscription's introductory price must not be advertised as unconditional.
    const schemaScope = root.closest('.shopify-section');
    const productSchema = schemaScope?.querySelector('[data-product-schema]');
    let schemaVariants = [];
    try { schemaVariants = JSON.parse(schemaScope?.querySelector('[data-schema-variants]')?.textContent || '[]'); } catch (_) {}
    const updateProductSchema = () => {
      if (!productSchema) return;
      const variant = schemaVariants.find(item => String(item.id) === String(variantInput.value));
      if (!variant) return;
      try {
        const schema = JSON.parse(productSchema.textContent);
        if (schema['@type'] !== 'Product' || schema.offers?.['@type'] !== 'Offer') return;
        const offerUrl = new URL(schema.offers.url);
        offerUrl.searchParams.set('variant', variant.id);
        offerUrl.searchParams.delete('selling_plan');
        schema.sku = variant.sku;
        schema.offers.name = variant.title;
        schema.offers.price = variant.price;
        schema.offers.availability = 'https://schema.org/' + (variant.available ? 'InStock' : 'OutOfStock');
        schema.offers.url = offerUrl.href;
        const updated = JSON.stringify(schema);
        if (productSchema.textContent !== updated) productSchema.textContent = updated;
      } catch (_) { /* Preserve server-rendered markup if optional schema data is unavailable. */ }
    };

    const applyState = () => {
      updateProductSchema();
      updateSelectedKitLabel();
      if (requiresPlan()) purchaseType = 'subscribe';
      else if (!selectedPlan && !pendingBladePlan) purchaseType = 'onetime';
      const bladeChoice = $('[data-blade-plan-choice]', root);
      if (bladeChoice) { bladeChoice.hidden = !pendingBladePlan; bladeChoice.textContent = pendingBladePlan ? uiText('blade_plan_choice') : ''; }
      if (!subData) { setPrice(curOneTime, curCompare); updateProductShipping(); updateStockAlternative(); updateStickyPurchase(); updateVisibleRitualOffer(); return; }
      root.dataset.purchaseType = purchaseType;
      // Hide only an explicitly marked subscription disclosure, never all payment terms.
      $$('[data-consent-type="subscription"], [data-subscription-disclosure]', root).forEach(terms => { terms.hidden = purchaseType === 'onetime'; });
      poCards.forEach(card => {
        const radio = $('input[type=radio]', card);
        const selected = card.dataset.po === purchaseType;
        card.classList.toggle('is-active', selected);
        if (radio) { radio.checked = selected; radio.disabled = !purchaseReady || (card.dataset.po === 'subscribe' ? !plansFor(variantInput.value).length : requiresPlan()); }
        card.hidden = card.dataset.po === 'subscribe' ? !plansFor(variantInput.value).length : requiresPlan();
      });
      if (freqSelect) freqSelect.disabled = !purchaseReady || !plansFor(variantInput.value).length;
      if (cadenceChoices) $$('input[type=radio]', cadenceChoices).forEach(radio => {
        radio.checked = String(selectedPlan?.id) === radio.value;
        radio.disabled = !purchaseReady || purchaseType !== 'subscribe';
      });
      const poOne = $('[data-po-onetime]', root); if (poOne) poOne.textContent = money(curOneTime);
      if (selectedPlan) {
        const subEl = $('[data-po-subprice]', root); if (subEl) subEl.textContent = money(selectedPlan.price);
        const badge = $('[data-po-save]', root); if (badge) { const saving = pct(curOneTime, selectedPlan.price); badge.textContent = saving > 0 ? uiText(root.classList.contains('pdp-razor') ? 'pdp_save_short' : 'save_today', { percent: saving }) : ''; }
      }
      if (pendingBladePlan) {
        const subEl = $('[data-po-subprice]', root); if (subEl) subEl.textContent = uiText('choose_frequency');
        const badge = $('[data-po-save]', root); if (badge) badge.textContent = '';
      }
      const mode = $('[data-price-mode]', root);
      if (purchaseType === 'subscribe' && selectedPlan) {
        const referencePrice = root.hasAttribute('data-blade-purchase') ? Math.max(curCompare, curOneTime) : curOneTime;
        setPrice(selectedPlan.price, referencePrice);
        if (mode) { mode.className = 'price-mode price-mode--club'; mode.textContent = uiText('with_ritual'); }
        if (sellingPlanInput) { sellingPlanInput.value = selectedPlan.id; sellingPlanInput.disabled = false; }
        if (freqWrap) freqWrap.hidden = false;
        if (atcText && isAvailable && !productAdding) atcText.textContent = uiText('add');
      } else {
        setPrice(curOneTime, curCompare);
        if (mode) { mode.className = 'price-mode'; mode.textContent = requiresPlan() || pendingBladePlan ? uiText('choose_frequency') : uiText('one_time_lower'); }
        if (sellingPlanInput) { sellingPlanInput.value = ''; sellingPlanInput.disabled = true; }
        if (freqWrap) freqWrap.hidden = !requiresPlan() && !pendingBladePlan;
        if (atcText && atcBtn && !atcBtn.disabled) atcText.textContent = uiText('add');
      }
      const planName = $('[data-po-plan-name]', root), renewalPrice = $('[data-po-renewal-price]', root), renewalAfter = $('[data-po-renewal-after]', root);
      const currentPurchaseUrl = purchaseUrl(location.href, purchaseType === 'subscribe' ? selectedPlan?.id : null);
      if (currentPurchaseUrl !== location.href) history.replaceState(history.state, '', currentPurchaseUrl);
      if (planName) planName.textContent = selectedPlan ? selectedPlan.name : '';
      const hasRenewal = selectedPlan && Number.isFinite(selectedPlan.renewalPrice) && Number.isInteger(selectedPlan.renewalAfterOrders) && selectedPlan.renewalAfterOrders >= 0;
      if (renewalPrice) renewalPrice.textContent = hasRenewal ? renewalCopy(selectedPlan, money) : uiText('renewal_unknown');
      if (renewalAfter) renewalAfter.textContent = '';
      const planDetails = $('[data-po-plan-details]', root);
      if (planDetails) {
        const shownInCadence = !root.classList.contains('pdp-razor') && cadenceChoices && !cadenceChoices.hidden && hasRenewal && selectedPlan.renewalAfterOrders === 0 && selectedPlan.price === selectedPlan.renewalPrice;
        planDetails.hidden = Boolean(shownInCadence);
      }
      if (root.classList.contains('pdp-razor')) {
        const preview = $('[data-pdp-renewal]', root);
        // Only rename the unit on this razor page; preserve Shopify amounts and cadence.
        const copy = hasRenewal ? renewalCopy(selectedPlan, money).replace(uiLanguage() === 'en' ? 'per item' : 'par article', uiLanguage() === 'en' ? 'per refill' : 'par recharge') : uiText('renewal_unknown');
        if (preview) preview.textContent = copy;
        if (renewalPrice) renewalPrice.textContent = copy;
      }
      updateProductShipping();
      if (atcBtn) atcBtn.disabled = !isAvailable || productAdding || ((requiresPlan() || !!pendingBladePlan) && !selectedPlan);
      updateStickyPurchase(); updateVisibleRitualOffer();
      updateSegPrices();
      updateStockAlternative();
    };
    poCards.forEach(card => $('input[type=radio]', card)?.addEventListener('change', () => {
      purchaseType = card.dataset.po;
      if (pendingBladePlan && purchaseType === 'onetime') { pendingBladePlan = null; rebuildFreq(); }
      applyState();
    }));
    cadenceChoices?.addEventListener('change', event => {
      if (event.target.matches('input[type=radio]') && freqSelect) {
        freqSelect.value = event.target.value;
        freqSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    freqSelect?.addEventListener('change', () => {
      const plans = plansFor(variantInput.value);
      selectedPlan = plans.find(p => String(p.id) === freqSelect.value) || null;
      if (selectedPlan) pendingBladePlan = null;
      applyState();
    });

    function updateProductShipping() {
      updateProductCta();
      const quantity = Math.max(1, parseInt($('[data-qty-input]', root)?.value || '1', 10) || 1);
      const amount = (purchaseType === 'subscribe' && selectedPlan ? selectedPlan.price : curOneTime) * quantity;
      const deliveryCountry = root.dataset.deliveryCountry || selectedDeliveryCountry();
      $$('[data-product-shipping]', root).forEach(link => {
        const eligible = shippingContextEligible(link.dataset, deliveryCountry, document.documentElement.dataset.marketCountry, window.Shopify?.currency?.active);
        link.textContent = eligible && purchaseType === 'subscribe' && selectedPlan ? link.dataset.shippingFreeText : productShippingMessage(amount, Number(link.dataset.shippingThreshold), eligible, link.dataset.shippingFreeText);
        link.setAttribute('aria-label', link.textContent + (link.target === '_blank' ? uiText('new_tab') : ''));
      });
    }
    root.addEventListener('delivery:country:change', updateProductShipping);
    root.addEventListener('change', event => { if (event.target.matches('[data-qty-input]')) { updateProductShipping(); updateStickyPurchase(); updateVisibleRitualOffer(); } });
    root.addEventListener('input', event => { if (event.target.matches('[data-qty-input]')) updateStickyPurchase(); updateVisibleRitualOffer(); });
    root.addEventListener('click', event => {
      if (event.target.closest('[data-qty-up], [data-qty-down]')) queueMicrotask(() => { updateProductShipping(); updateStickyPurchase(); updateVisibleRitualOffer(); });
    });

    /* Single-option variant cards */
    const kitPicker = $('[data-kit-picker]', root);
    const kitToggle = kitPicker && $('[data-kit-details-toggle]', kitPicker);
    if (kitToggle) {
      kitPicker.classList.add('is-details-collapsed');
      kitToggle.setAttribute('aria-expanded', 'false');
      kitToggle.hidden = false;
      kitToggle.addEventListener('click', () => {
        const expanded = kitToggle.getAttribute('aria-expanded') !== 'true';
        kitPicker.classList.toggle('is-details-collapsed', !expanded);
        kitToggle.setAttribute('aria-expanded', String(expanded));
      });
    }

    const cards = $$('[data-variant-card]', root);
    cards.forEach(card => {
      $('input[type=radio]', card)?.addEventListener('change', () => {
        // Sold-out cards stay selectable on purpose: selecting one reveals the
        // back-in-stock form (setAvailability handles the swap below).
        cards.forEach(c => c.classList.remove('is-active'));
        card.classList.add('is-active');
        root.querySelectorAll('[data-pdp-kit-panel]').forEach(panel => {
          panel.hidden = panel.dataset.pdpKitPanel !== card.dataset.variantId;
        });
        root.querySelectorAll('[data-kit-column]').forEach(cell => {
          cell.classList.toggle('is-selected', cell.dataset.kitColumn === card.dataset.variantId);
        });
        const radio = $('input[type=radio]', card);
        if (radio) radio.checked = true;
        variantInput.value = card.dataset.variantId;
        curOneTime = parseInt(card.dataset.variantPrice);
        curCompare = parseInt(card.dataset.variantCompare) || 0;
        rebuildFreq();
        applyState();
        setAvailability(card.dataset.variantAvailable === 'true');
        const label = $('[data-selected-label]', root);
        if (label) label.textContent = $('.variant-card__name', card)?.textContent || '';
        productGallery?.selectVariant(card.dataset.variantId, card.dataset.variantMediaId);
        { const u = new URL(location.href); u.searchParams.set('variant', card.dataset.variantId); history.replaceState({}, '', u); }
      });
    });

    // Delegate so guide sections inserted or replaced after initialization keep working.
    // The hash fallback preserves the current contract if JavaScript is unavailable.
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-blade-guide-choice]');
      if (!link || link.dataset.productId !== root.dataset.productId) return;
      const card = cards.find(candidate => candidate.dataset.variantId === link.dataset.bladeGuideChoice);
      const radio = card && $('input[type=radio]', card);
      if (!purchaseReady || !radio || radio.disabled) return;
      event.preventDefault();
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      const target = pendingBladePlan ? $('[data-blade-plan-choice]', root) : card;
      target?.setAttribute('tabindex', '-1');
      target?.scrollIntoView({ behavior: 'instant', block: 'center' });
      target?.focus({ preventScroll: true });
    });

    /* Keep Shopify's native contact submission, including its challenge and server errors. */
    if (restock) {
      const rForm = $('[data-restock-form]', restock);
      rForm?.addEventListener('submit', () => {
        const active = $('[data-variant-card].is-active', root);
        const body = $('[name="contact[body]"]', rForm);
        if (body) body.value = uiText('availability_request', { title: document.title, variant: active?.dataset.variantTitle || '', id: variantInput.value, url: location.href });
      });
    }

    /* Multi-option swatches */
    const variantsJSON = $('[data-variants-json]', root);
    let variants = null;
    if (variantsJSON) { try { variants = JSON.parse(variantsJSON.textContent); } catch (e) {} }
    if (variants) {
      const selected = {};
      $$('[data-swatch].is-active', root).forEach(s => selected[s.dataset.option] = s.dataset.value);
      $$('[data-swatch]', root).forEach(sw => {
        sw.addEventListener('click', () => {
          const opt = sw.dataset.option;
          $$(`[data-swatch][data-option="${opt}"]`, root).forEach(x => x.classList.remove('is-active'));
          sw.classList.add('is-active');
          selected[opt] = sw.dataset.value;
          const lbl = $(`[data-selected-for="${opt - 1}"]`, root);
          if (lbl) lbl.textContent = sw.dataset.value;
          const match = variants.find(v =>
            (!selected['1'] || v.option1 === selected['1']) &&
            (!selected['2'] || v.option2 === selected['2']) &&
            (!selected['3'] || v.option3 === selected['3']));
          if (match) {
            variantInput.value = match.id;
            curOneTime = match.price;
            curCompare = match.compare_at_price || 0;
            rebuildFreq();
            applyState();
            setAvailability(match.available);
            { const u = new URL(location.href); u.searchParams.set('variant', match.id); history.replaceState({}, '', u); }
          } else { setAvailability(false); }
        });
      });
    }

    /* Init pricing/subscription state */
    (function initBuy() {
      const active = $('[data-variant-card].is-active', root);
      if (active) { curOneTime = parseInt(active.dataset.variantPrice); curCompare = parseInt(active.dataset.variantCompare) || 0; }
      else if (subData && subData[variantInput.value]) { curOneTime = subData[variantInput.value].oneTime; }
      else if (priceEl) { curOneTime = Math.round(parseFloat((priceEl.textContent || '0').replace(/[^\d.,]/g, '').replace(',', '.')) * 100); }
      const activePo = $('[data-po-card].is-active', root);
      if (activePo) purchaseType = activePo.dataset.po;
      if (sellingPlanInput?.value) selectedPlan = plansFor(variantInput.value).find(plan => String(plan.id) === sellingPlanInput.value) || null;
      rebuildFreq();
      applyState();
      setAvailability(isAvailable);
      purchaseReady = true;
      applyState();
      $$('[data-variant-card] input[type="radio"]', root).forEach(radio => { radio.disabled = false; });
      if (variants) $$('[data-swatch]', root).forEach(swatch => { swatch.disabled = false; });
    })();
    // Emit the initial view once, after the exact variant and purchase option are ready.
    const initialViewPrice = (purchaseType === 'subscribe' && selectedPlan ? selectedPlan.price : curOneTime) / 100;
    if (Number.isFinite(initialViewPrice)) {
      const selectedCard = $('[data-variant-card].is-active', root);
      const selectedVariant = variants?.find(variant => String(variant.id) === variantInput.value);
      track('view_item', { currency: window.Shopify?.currency?.active || 'EUR', value: initialViewPrice, items: [{
        item_id: root.dataset.productId || root.dataset.productHandle,
        item_name: $('h1', root)?.textContent.trim(),
        item_variant: selectedCard?.dataset.variantTitle || selectedVariant?.title || variantInput.value,
        price: initialViewPrice
      }] });
    }

    // Official Recharge legacy lifecycle hooks, restricted to our custom subscription PDP.
    // https://docs.getrecharge.com/do/docs/advanced-widget-use-cases
    if (root.hasAttribute('data-custom-subscriptions') && sellingPlanInput && form) {
      // Late Recharge injection can prepend a second successful selling_plan control.
      // Shopify wallets read form.elements.namedItem(...).item(0), whereas our cart uses
      // data-selling-plan. Keep one authoritative named control without deleting app UI.
      const normalizeSellingPlanFields = () => {
        if (!form.contains(sellingPlanInput)) form.appendChild(sellingPlanInput);
        if (sellingPlanInput.name !== 'selling_plan') sellingPlanInput.name = 'selling_plan';
        $$('[name="selling_plan"]', form).forEach(input => {
          if (input !== sellingPlanInput) {
            input.setAttribute('data-gs-foreign-selling-plan', '');
            input.removeAttribute('name');
          }
        });
      };
      normalizeSellingPlanFields();
      const sellingPlanObserver = new MutationObserver(normalizeSellingPlanFields);
      sellingPlanObserver.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['name'] });
      // The submit capture also covers a same-task injection before observer delivery.
      form.addEventListener('submit', normalizeSellingPlanFields, true);
      let rechargeCleanupQueued = false, destroyingRecharge = false;
      const scheduleRechargeCleanup = () => {
        if (rechargeCleanupQueued || destroyingRecharge) return;
        rechargeCleanupQueued = true;
        Promise.resolve().then(() => {
          rechargeCleanupQueued = false;
          const widget = window.ReChargeWidget;
          if (!purchaseReady || typeof widget?.destroyWidgets !== 'function') return;
          destroyingRecharge = true;
          try { widget.destroyWidgets(); } catch (_) { /* Scoped CSS keeps a failed legacy widget inaccessible. */ }
          finally {
            normalizeSellingPlanFields();
            applyState(); setAvailability(isAvailable);
            destroyingRecharge = false;
          }
        });
      };
      ['ReChargeWidget-loaded', 'widget:build'].forEach(event => {
        document.addEventListener(event, scheduleRechargeCleanup);
        window.addEventListener(event, scheduleRechargeCleanup);
      });
      scheduleRechargeCleanup();
    }

    /* Submit → AJAX add */
    const doAdd = async (btn) => {
      if (!cartActionAllowed(btn)) return;
      const cartOpeningRevision = cartDismissRevision;
      if (productAdding || !isAvailable || ((requiresPlan() || !!pendingBladePlan) && !selectedPlan)) return;
      const qty = Math.max(1, parseInt($('[data-qty-input]', root)?.value || 1) || 1);
      const sp = (sellingPlanInput && !sellingPlanInput.disabled && sellingPlanInput.value) ? sellingPlanInput.value : null;
      productAdding = true;
      if (atcText) atcText.textContent = uiText('adding');
      if (atcBtn) { atcBtn.disabled = true; atcBtn.setAttribute('aria-busy', 'true'); }
      if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = uiText('adding'); stickyBtn.setAttribute('aria-busy', 'true'); }
      updateProductCta();
      try {
        const properties = root.hasAttribute('data-groombox-product') ? Object.fromEntries(
          [...form.querySelectorAll('[data-gb-property]:not([disabled])')].map(field => [field.name.slice(11, -1), field.value])
        ) : null;
        const result = await addToCart(variantInput.value, qty, sp, properties);
        showToast(result.notice || (sp ? uiText('ritual_added') : uiText('added')));
        openCartAfterAdd(cartOpeningRevision);
      } catch (err) { showToast(err.message || uiText('error')); }
      finally { productAdding = false; atcBtn?.removeAttribute('aria-busy'); stickyBtn?.removeAttribute('aria-busy'); applyState(); setAvailability(isAvailable); }
    };
    form?.addEventListener('submit', (e) => { e.preventDefault(); doAdd(atcBtn); });
    const editPurchase = () => {
      const controls = $$('input:not([type="hidden"]):not([disabled]), select:not([disabled]), button:not([disabled])', form);
      const target = controls.find(node => !node.closest('[hidden], [inert]') && node.getClientRects().length > 0) || form;
      if (!target) return;
      if (target === form) target.setAttribute('tabindex', '-1');
      target.scrollIntoView({ behavior: 'instant', block: 'center' });
      target.focus({ preventScroll: true });
    };
    stickyBtn?.addEventListener('click', () => {
      updateStickyPurchase(); updateVisibleRitualOffer();
      if (stickyBtn.disabled) return;
      if (!stickyCanAdd) { editPurchase(); return; }
      doAdd(stickyBtn);
    });
    $('[data-sticky-edit]')?.addEventListener('click', event => { event.preventDefault(); editPurchase(); });

    /* Expose the existing action after a real price is seen, except while the main action is visible.
       Razor prices begin in the kit selector; its redundant gallery price has been removed. */
    const priceExposureTarget = root.classList.contains('pdp-razor') ? $('[data-seg-price]', root) || $('[data-po-onetime]', root) : priceEl;
    if (stickyBar && priceExposureTarget) {
      let priceSeen = false;
      const refresh = () => {
        const viewportHeight = window.visualViewport?.height || window.innerHeight;
        const priceRect = priceExposureTarget.getBoundingClientRect();
        if (priceRect.top < viewportHeight) priceSeen = true; // Includes restored scroll positions and deep links below the price.
        const mainRect = atcBtn?.getBoundingClientRect();
        const headerBottom = Math.max(0, $('[data-header]')?.getBoundingClientRect().bottom || 0);
        const mainVisible = !!mainRect && atcBtn.getClientRects().length > 0 && mainRect.top >= headerBottom && mainRect.bottom <= viewportHeight;
        const editingText = document.activeElement?.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="button"]), textarea, select, [contenteditable="true"]');
        const keyboardOpen = !!editingText && !!window.visualViewport && window.innerHeight - viewportHeight > 120;
        const modalOpen = !!activeModal || document.body.classList.contains('no-scroll');
        const visible = priceSeen && !mainVisible && !modalOpen && !keyboardOpen;
        if (!visible && !modalOpen && stickyBar.contains(document.activeElement)) {
          const target = mainVisible ? atcBtn : priceExposureTarget;
          if (target === priceExposureTarget) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        }
        // Modal helpers own their inert snapshots. Do not overwrite them while a modal is active.
        if (!activeModal) stickyBar.toggleAttribute('inert', !visible);
        stickyBar.setAttribute('aria-hidden', String(!visible));
        stickyBar.classList.toggle('is-visible', visible);
      };
      refreshProductAction = refresh;
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(refresh, { threshold: [0, 1] });
        observer.observe(priceExposureTarget); if (atcBtn) observer.observe(atcBtn);
      }
      const updateHeight = () => document.documentElement.style.setProperty('--gs-product-action-height', Math.ceil(stickyBar.getBoundingClientRect().height) + 'px');
      if ('ResizeObserver' in window) new ResizeObserver(updateHeight).observe(stickyBar);
      document.body.dataset.productActionReady = 'true';
      window.addEventListener('scroll', refresh, { passive: true });
      window.addEventListener('resize', refresh, { passive: true });
      window.visualViewport?.addEventListener('resize', refresh, { passive: true });
      document.addEventListener('focusin', refresh);
      new MutationObserver(refresh).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      updateHeight(); refresh();
    }
  }

  /* ============================================================
     FAQ accordions
     ============================================================ */
  $$('[data-faq-q]').forEach(q => {
    const item = q.closest('.faq__item');
    const ans = item && $('.faq__a', item);
    if (ans && !item.classList.contains('is-open')) ans.setAttribute('inert', '');
    q.addEventListener('click', () => {
      if (!item) return;
      const open = item.classList.toggle('is-open');
      q.setAttribute('aria-expanded', open);
      if (ans) {
        ans.style.maxHeight = open ? ans.scrollHeight + 'px' : '0px';
        if (open) { ans.removeAttribute('inert'); } else { ans.setAttribute('inert', ''); }
      }
    });
  });

  /* ============================================================
     Announcement rotation
     ============================================================ */
  const ann = $('[data-announce]');
  if (ann) {
    const slides = $$('[data-announce-slide]', ann);
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (slides.length > 1 && !reduce) {
      let i = 0, paused = false;
      const delay = (parseInt(ann.dataset.speed) || 4) * 1000;
      setInterval(() => {
        if (paused) return;
        slides[i].hidden = true;
        i = (i + 1) % slides.length;
        slides[i].hidden = false;
      }, delay);
      ann.addEventListener('mouseenter', () => { paused = true; });
      ann.addEventListener('mouseleave', () => { paused = false; });
      ann.addEventListener('focusin', () => { paused = true; });
      ann.addEventListener('focusout', () => { paused = false; });
    }
  }

  /* Re-observe reveals after Shopify section reload (theme editor) */
  document.addEventListener('shopify:section:load', (e) => observeReveals(e.target));
})();

// D252: hover on desktop, native details tap/keyboard behavior retained.
(() => {
 if (typeof document === 'undefined') return;
 const init = () => document.querySelectorAll('.gs-localization').forEach(el => {
  if (el.dataset.hoverReady) return;
  el.dataset.hoverReady = 'true';
  let timer;
  el.addEventListener('pointerenter', e => {
   if (e.pointerType !== 'mouse' || !matchMedia('(hover:hover)').matches) return;
   clearTimeout(timer); el.open = true;
  });
  el.addEventListener('pointerleave', e => {
   if (e.pointerType !== 'mouse') return;
   timer = setTimeout(() => { if (!el.contains(document.activeElement)) el.open = false; }, 160);
  });
  el.addEventListener('focusout', () => setTimeout(() => {
   if (!el.contains(document.activeElement) && !el.matches(':hover')) el.open = false;
  }, 0));
  el.addEventListener('keydown', e => { if (e.key === 'Escape') { el.open = false; el.querySelector('summary')?.focus(); } });
  document.addEventListener('pointerdown', e => { if (!el.contains(e.target)) el.open = false; });
 });
 init(); document.addEventListener('shopify:section:load', init);
})();

// D255: direct choices with native Shopify form submission as fallback.
(() => {
 if (typeof document === 'undefined') return;
 const init = () => document.querySelectorAll('.gs-localization__form select').forEach(select => {
  if (select.dataset.choiceList) return;
  select.dataset.choiceList = 'true';
  const list = document.createElement('div');
  list.className = 'gs-localization__choices';
  list.setAttribute('role', 'group');
  const label = select.form.querySelector('label[for="' + select.id + '"]');
  if (label) list.setAttribute('aria-label', label.textContent.trim());
  const isFooter = !!select.closest('.gs-localization--footer');
  let europe, europeChoices;
  if (isFooter && select.name === 'country_code') {
   europe = document.createElement('details'); europe.className = 'gs-market-europe';
   const summary = document.createElement('summary'); summary.textContent = 'Europe';
   const flag = document.createElement('img'); flag.src = 'https://flagcdn.com/w40/eu.png'; flag.alt = ''; flag.width = 18; flag.height = 12; summary.prepend(flag);
   europeChoices = document.createElement('div'); europeChoices.className = 'gs-market-europe__countries';
   europe.append(summary, europeChoices); list.append(europe);
  }
  const order = ['FR','BE','LU','MC','CH','US','GB','CA'];
  const options = Array.from(select.options);
  if (isFooter && select.name === 'country_code') options.sort((a,b)=>order.indexOf(a.value)-order.indexOf(b.value));
  options.forEach(option => {
   const button = document.createElement('button');
   button.type = 'button';
   button.className = 'gs-localization__choice';
   const footer = select.closest('.gs-localization--footer');
   const currency = option.textContent.match(/\(([^)]+)\)/)?.[1] || '';
   const country = select.name === 'country_code';
   const flag = country ? Array.from(option.value.toUpperCase()).map(c => String.fromCodePoint(127397 + c.charCodeAt(0))).join('') : '';
   const fullLanguageName = isFooter || !!select.closest('.gs-localization--mobile');
   button.textContent = footer && country ? flag + ' ' + option.textContent.replace(/\s*\([^)]+\)/, '') : country ? option.value + ' · ' + currency : fullLanguageName ? option.textContent.trim() : option.value.toUpperCase();
   if (!country) button.lang = option.value;
   if (footer && country) {
    button.textContent = option.textContent.replace(/\s*\([^)]+\)/, '');
    const flagImage = document.createElement('img');
    flagImage.src = 'https://flagcdn.com/w40/' + option.value.toLowerCase() + '.png';
    flagImage.alt = ''; flagImage.width = 18; flagImage.height = 12;
    flagImage.style.objectFit = 'cover'; button.prepend(flagImage);
   }
   button.title = option.textContent;
   button.setAttribute('aria-label', option.textContent);
   button.setAttribute('aria-pressed', String(option.selected));
   button.addEventListener('click', () => {
    if (select.form.dataset.submitting || select.value === option.value) return;
    select.value = option.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
   });
   if (europeChoices && ['FR','BE','LU','MC'].includes(option.value)) europeChoices.append(button); else list.append(button);
  });
  select.after(list); select.hidden = true;
 });
 init(); document.addEventListener('shopify:section:load', init);
})();

